import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BusinessIcon from '@mui/icons-material/Business';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EmailIcon from '@mui/icons-material/Email';
import LanguageIcon from '@mui/icons-material/Language';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PersonIcon from '@mui/icons-material/Person';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import UploadIcon from '@mui/icons-material/Upload';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import {
  Alert,
  Avatar,
  Box,
  Button,
  Chip,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputLabel,
  Link,
  Menu,
  MenuItem,
  Select,
  SelectChangeEvent,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { DataGrid, GridColDef as MuiGridColDef } from '@mui/x-data-grid';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import axios from 'axios';
import 'compression-streams-polyfill';
import dayjs, { Dayjs } from 'dayjs';
import Cookies from 'js-cookie';
import { useCallback, useEffect, useState } from 'react';
import binIcon from '../assets/bin.png';
import BlocsysConnections from '../assets/blocsysConnections.png';
import linkedinIcon from '../assets/business.png';
import contactedIcon from '../assets/contacted.png';
import cryptoInvestmenticon from '../assets/crypto_investment.png';
import cryptoInvestoricon from '../assets/crypto_Investor.png';
import Email from '../assets/email.png';
import coinGeko from '../assets/exchange.png';
import followupIcon from '../assets/followup.png';
import instagramIcon from '../assets/instagram.png';
import ValidEmail from '../assets/letter.png';
import notConnectedIcon from '../assets/notConnected.png';
import lumaIcon from '../assets/Scrapping.png';
import ConnctionIcon from '../assets/social-network.png';
import token2049icon from '../assets/token2049.png';
import twitterIcon from '../assets/twitter.png';
import backendService from '../components/backendservices/BackendService';
import {
  ApiError,
  EditedFields,
  FollowUp,
  FollowUpFilterType,
  FormattedUser,
  QueryParams,
  User,
} from '../types/Contacts';
import { parseLocation } from '../utils/locationUtils';

type GridColDef = MuiGridColDef<FormattedUser>;

function jsonToCSV(items: Record<string, any>[]): string {
  if (!items.length) return '';
  const replacer = (_key: string, value: any) =>
    value === null || value === undefined ? '' : value;
  const header = Object.keys(items[0]);
  const csv = [
    header.join(','), // header row first
    ...items.map((row) =>
      header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(',')
    ),
  ].join('\r\n');
  return csv;
}

const Contacts: React.FC = () => {
  const userRole = Cookies.get('role');
  const isSales = userRole === 'sales';
  const [tableData, setTableData] = useState<FormattedUser[]>([]);
  const [selectedUser, setSelectedUser] = useState<FormattedUser | null>(null);
  const [selectedUserFilter, setSelectedUserFilter] = useState<string>('');
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>('');
  const [file, setFile] = useState<File | null>(null);
  const [rowCount, setRowCount] = useState<number>(0);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingUpload, setLoadingUpload] = useState<boolean>(false);
  const [loadingWebscrap, setLoadingWebscrap] = useState<boolean>(false);
  const [loadingTwitter, setLoadingTwitter] = useState<boolean>(false);
  const [loadingInsta, setLoadingInsta] = useState<boolean>(false);
  const [loadingEmailValid, setLoadingEmailValid] = useState<boolean>(false);
  const [exportPages, setExportPages] = useState('current'); // 'current', 'all', or a number
  const [loadingLuma, setLoadingLuma] = useState<boolean>(false);
  const [loadingCoinGecko, setLoadingCoinGecko] = useState<boolean>(false);
  const [loadingUrlScrape, setLoadingUrlScrape] = useState<boolean>(false);
  const [urlToScrape, setUrlToScrape] = useState<string>('');
  const [csvFile, setCsvFile] = useState<File | null>(null);
  const [loadingCsvUpload, setLoadingCsvUpload] = useState<boolean>(false);
  const [showButtons, setShowButtons] = useState<'csv' | 'file' | null>(null);
  const [csvNames, setCsvNames] = useState<string[]>([]);
  const [selectedCsvName, setSelectedCsvName] = useState<string>('');
  const [showCsvPreview, setShowCsvPreview] = useState<boolean>(false);
  const [snackbarType, setSnackbarType] = useState<'success' | 'error' | 'warning' | 'info'>(
    'success'
  );

  const [contacted, setContacted] = useState<string>('false');
  const [notContacted, setNotContacted] = useState<string>('false');
  const [linkedin, setLinkedin] = useState<string>('false');
  const [twitter, setTwitter] = useState<string>('false');
  const [instagram, setIntagram] = useState<string>('false');
  const [facebook, setFacebook] = useState<string>('false');
  const [followUpFilter, setFollowUpFilter] = useState<FollowUpFilterType | null>(null);
  const [editingRow, setEditingRow] = useState<string | null>(null);
  const [editedData, setEditedData] = useState<FormattedUser | null>(null);
  const [nameSearch, setNameSearch] = useState<string>('');
  const [trash, setTrash] = useState<string>('false');
  const [token2049, setToken2049] = useState<string>('false');
  const [istoken2049SNG25, setIstoken2049SNG25] = useState<string>('false');
  const [cryptoInvestor, setCryptoInvestor] = useState<string>('false');
  const [cryptoInvestment, setCryptoInvestment] = useState<string>('false');
  const [isCryptoslate, setIsCryptoslate] = useState<string>('false');
  const [coinGecko, setCoinGecko] = useState<string>('false');
  const [blocsysConnections, setBlocsysConnections] = useState<string>('false');
  const [validEmail, setValidEmail] = useState<string>('false');
  const [email, setEmail] = useState<string>('false');
  const [lumaFilter, setLumaFilter] = useState<string>('false');
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [users, setUsers] = useState<User[]>([]);
  const [page, setPage] = useState(0); // starts at 0 for MUI
  const [pageSize, setPageSize] = useState(10);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<FormattedUser | null>(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState<FormattedUser | null>(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogConfig, setConfirmDialogConfig] = useState<{
    title: string;
    message: string;
    onConfirm: () => void;
  } | null>(null);
  const [assigningUser, setAssigningUser] = useState<string | null>(null); // Track which row is being assigned

  const fetchAllFiles = useCallback(async (): Promise<void> => {
    try {
      setLoading(true);

      // Create params object with only true values
      // Use _id for sorting as it contains timestamp and is indexed by default
      const params: QueryParams = {
        sortBy: '_id',
        sortOrder: 'desc',
      };

      // Add date filters if they exist
      if (nameSearch.trim()) {
        params.name = nameSearch.trim();
      }
      if (startDate) {
        params.startDate = dayjs(startDate).format('YYYY-MM-DD');
      }
      if (endDate) {
        params.endDate = dayjs(endDate).format('YYYY-MM-DD');
      }

      // Add boolean filters only if they are true
      if (contacted === 'true') params.isContacted = true;
      if (notContacted === 'true') params.uncontacted = true;
      if (linkedin === 'true') params.linkedInProfileUrl = true;
      if (twitter === 'true') params.twitterProfileUrl = true;
      if (instagram === 'true') params.instagramProfileUrl = true;
      if (facebook === 'true') params.isConnectionSend = true;
      if (validEmail === 'true') params.isEmailValid = true;
      if (token2049 === 'true') params.token2049 = true;
      if (istoken2049SNG25 === 'true') params.istoken2049SNG25 = true;
      if (cryptoInvestor === 'true') params.iscryptoRank = true;
      if (cryptoInvestment === 'true') params.iscryptoRankInvestment = true;
      if (email === 'true') params.email = true;
      if (coinGecko === 'true') params.iscoingecko = true;
      if (blocsysConnections === 'true') params.isblocsysLinkedinConnection = true;
      if (isCryptoslate === 'true') params.isCryptoslate = true;
      if (lumaFilter === 'true') params.isLumaScrapped = true;
      if (selectedUserFilter) params.filterByUsername = selectedUserFilter;

      // Add follow-up filter only if it's selected
      if (followUpFilter) {
        if (followUpFilter === 'followup1') params.followup1 = true;
        if (followUpFilter === 'followup2') params.followup2 = true;
        if (followUpFilter === 'followup3') params.followup3 = true;
        if (followUpFilter === 'followupAll') params.followupAll = true;
      }

      // Add CSV name filter if selected
      if (selectedCsvName) params.csvName = selectedCsvName;

      // Get token from cookies
      const token = Cookies.get('token');
      let response;

      if (trash === 'true') {
        response = await axios.get<{
          success: boolean;
          count: number;
          totalUsers: number;
          data: User[];
          takenByUsers?: User[];
        }>(`${process.env.REACT_APP_BASE_URL}/user/getTrashUser`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      } else {
        response = await axios.get<{
          success: boolean;
          totalUsers: number;
          count: number;
          data: User[];
          takenByUsers?: User[];
        }>(
          `${process.env.REACT_APP_BASE_URL}/user/getAllUsers?page=${page + 1}&limit=${pageSize}`,
          {
            params,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data && response.data.success && Array.isArray(response.data.data)) {
        const userData = response.data.data;
        const totalCount = trash === 'true' ? response.data.count : response.data.totalUsers;

        const formattedData: FormattedUser[] = userData.map((item, index) => {
          // Parse location for city, state, country if needed
          const {
            city: derivedCity,
            state: derivedState,
            country: derivedCountry,
          } = parseLocation(item.location);

          // Get the latest follow-up index
          const followUpsLength = item.followUps?.length || 0;
          const latestFollowUpIndex = followUpsLength > 0 ? followUpsLength - 1 : 0;
          const selectedFollowUp = item.selectedFollowUp || `followup-${latestFollowUpIndex + 1}`;
          const selectedFollowUpIndex =
            selectedFollowUp === 'followup-1'
              ? 0
              : selectedFollowUp === 'followup-2'
                ? 1
                : selectedFollowUp === 'followup-3'
                  ? 2
                  : latestFollowUpIndex;

          // Get the selected follow-up or default to latest follow-up
          const followUp = item.followUps?.[selectedFollowUpIndex] || {
            _id: '',
            isFollowUpActive: false,
            status: 'Not Started',
            response: '',
            reminders: new Date().toISOString(),
          };

          return {
            id: item._id,
            srNo: page * pageSize + index + 1,
            name: item.name || 'N/A',
            linkedin: item.socials?.linkedIn?.profileUrls?.[0] || 'N/A',
            twitter: item.socials?.twitter?.profileUrls?.[0] || 'N/A',
            facebook: item.socials?.facebook?.profileUrls?.[0] || 'N/A',
            instagram: item.socials?.instagram?.profileUrls?.[0] || 'N/A',
            email: item.email || 'N/A',
            followUpActive: item.followUps?.some((fu) => fu.isFollowUpActive)
              ? 'Active'
              : 'Not Active',
            contacted: item.contacted?.isContacted ? 'Yes' : 'No',
            leadStatus: item.leadStatus || 'N/A',
            followUps: item.followUps || [],
            connectionsType: item.connectionsType || 'N/A',
            contractType: item.contractType || 'N/A',
            userAdditionalInfo: item.userAdditionalInfo || 'N/A',
            comments: item.comments || 'N/A',
            companyName: item.companyName || 'N/A',
            jobTitle: item.jobTitle || 'N/A',
            country: item.country || derivedCountry,
            state: item.state || derivedState,
            city: item.city || derivedCity,
            location: item.location || 'N/A',
            followUpStatus: followUp.status || 'Not Started',
            followUpResponse: followUp.response || '',
            followUpReminder: followUp.reminders || new Date().toISOString(),
            selectedFollowUp: selectedFollowUp,
            companyWebUrl: item.companyWebUrl || 'N/A',
            isConnectionSend: item.isConnectionSend ? 'Yes' : 'No',
            takenBy: item.takenBy || followUp.takenBy || '',
            createdAt: item.createdAt || 'N/A',
          };
        });

        setTableData(formattedData);
        setRowCount(totalCount);
        if (response.data.takenByUsers && Array.isArray(response.data.takenByUsers)) {
          setUsers(response.data.takenByUsers);
        }
      } else {
        console.error('Invalid response format:', response.data);
        setTableData([]);
        setSnackbarMessage('Invalid data format received from server');
        setSnackbarType('error');
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error('Error fetching all users:', error);
      setTableData([]);
      setSnackbarMessage('Error fetching users data');
      setSnackbarType('error');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  }, [
    startDate,
    endDate,
    contacted,
    notContacted,
    linkedin,
    twitter,
    instagram,
    facebook,
    followUpFilter,
    nameSearch,
    lumaFilter,
    trash,
    token2049,
    istoken2049SNG25,
    cryptoInvestor,
    cryptoInvestment,
    coinGecko,
    blocsysConnections,
    selectedUserFilter,
    email,
    page,
    pageSize,
    validEmail,
    isCryptoslate,
    selectedCsvName,
    setLoading,
    setTableData,
    setRowCount,
    setSnackbarMessage,
    setSnackbarType,
    setSnackbarOpen,
  ]);

  // useEffect(() => {
  //   if (!process.env.REACT_APP_BASE_URL) {
  //     console.error('REACT_APP_BASE_URL is not defined in environment variables');
  //     setSnackbarMessage('API URL not configured');
  //     setSnackbarType('error');
  //     setSnackbarOpen(true);
  //     return;
  //   }
  //   fetchAllFiles();
  // }, [
  //   contacted,
  //   notContacted,
  //   linkedin,
  //   twitter,
  //   instagram,
  //   facebook,
  //   followUpFilter,
  //   startDate,
  //   endDate,
  //   fetchAllFiles,
  // ]);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      fetchAllFiles();
    }, 1000); // Wait 1000ms after last change before fetching

    return () => clearTimeout(debounceTimer);
  }, [nameSearch, fetchAllFiles]);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    if (event.target.files && event.target.files[0]) {
      setFile(event.target.files[0]);
    }
  };

  const handleUserChange = (event: SelectChangeEvent<string>) => {
    setSelectedUserFilter(event.target.value);
    setTrash('false');
  };

  const getUsers = async () => {
    try {
      const response = await backendService.Get(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/users?page=1`
      );
      if (response.status === 200) {
        setUsers(response.data);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const getCsvNames = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/user/getAllCsvNames`);
      if (response.data.success) {
        setCsvNames(response.data.data.csvNames || []);
      }
    } catch (error) {
      console.error('Error fetching CSV names:', error);
    }
  };

  useEffect(() => {
    getUsers();
    getCsvNames();
  }, []);

  const handleDownloadCSV = async () => {
    const numPages = parseInt(exportPages, 10);
    if (isNaN(numPages) || numPages <= 0) {
      setSnackbarMessage('Please enter a valid number of pages!');
      setSnackbarType('error');
      setSnackbarOpen(true);
      return;
    }

    setIsExporting(true);
    try {
      const limitValue = numPages * pageSize;
      const allData = await fetchAllDataForExport(limitValue);

      if (!allData.length) {
        setSnackbarMessage('No data to export!');
        setSnackbarType('warning');
        setSnackbarOpen(true);
        return;
      }

      const csv = jsonToCSV(allData);
      downloadCSVFile(csv, `contacts_${numPages}_pages`);

      setSnackbarMessage(`Successfully exported ${allData.length} records!`);
      setSnackbarType('success');
      setSnackbarOpen(true);
    } catch (error) {
      setSnackbarMessage('Error exporting CSV file.');
      setSnackbarType('error');
      setSnackbarOpen(true);
    } finally {
      setIsExporting(false);
    }
  };

  const fetchAllDataForExport = async (limit?: number): Promise<FormattedUser[]> => {
    try {
      // Create params object with current filters (same as your existing logic)
      const params: QueryParams = {
        sortBy: '_id',
        sortOrder: 'desc',
      };

      // Add all your current filters
      if (nameSearch.trim()) params.name = nameSearch.trim();
      if (startDate) params.startDate = dayjs(startDate).format('YYYY-MM-DD');
      if (endDate) params.endDate = dayjs(endDate).format('YYYY-MM-DD');
      if (contacted === 'true') params.isContacted = true;
      if (notContacted === 'true') params.uncontacted = true;
      if (linkedin === 'true') params.linkedInProfileUrl = true;
      if (twitter === 'true') params.twitterProfileUrl = true;
      if (instagram === 'true') params.instagramProfileUrl = true;
      if (facebook === 'true') params.isConnectionSend = true;
      if (validEmail === 'true') params.isEmailValid = true;
      if (token2049 === 'true') params.token2049 = true;
      if (istoken2049SNG25 === 'true') params.istoken2049SNG25 = true;
      if (cryptoInvestor === 'true') params.iscryptoRank = true;
      if (cryptoInvestment === 'true') params.iscryptoRankInvestment = true;
      if (email === 'true') params.email = true;
      if (coinGecko === 'true') params.iscoingecko = true;
      if (blocsysConnections === 'true') params.isblocsysLinkedinConnection = true;
      if (isCryptoslate === 'true') params.isCryptoslate = true;
      if (lumaFilter === 'true') params.isLumaScrapped = true;
      if (selectedUserFilter) params.filterByUsername = selectedUserFilter;
      if (selectedCsvName) params.csvName = selectedCsvName;

      if (followUpFilter) {
        if (followUpFilter === 'followup1') params.followup1 = true;
        if (followUpFilter === 'followup2') params.followup2 = true;
        if (followUpFilter === 'followup3') params.followup3 = true;
        if (followUpFilter === 'followupAll') params.followupAll = true;
      }

      const token = Cookies.get('token');

      // Build URL with or without limit
      let url = `${process.env.REACT_APP_BASE_URL}/user/getAllUsers?page=1`;
      if (limit) {
        url += `&limit=${limit}`;
      }
      // If no limit is specified, backend should return all records

      const response = await axios.get<{
        success: boolean;
        totalUsers: number;
        count: number;
        data: User[];
      }>(url, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data && response.data.success && Array.isArray(response.data.data)) {
        const userData = response.data.data;

        // Format the data (same logic as in fetchAllFiles)
        const formattedData: FormattedUser[] = userData.map((item, index) => {
          const {
            city: derivedCity,
            state: derivedState,
            country: derivedCountry,
          } = parseLocation(item.location);

          const followUpsLength = item.followUps?.length || 0;
          const latestFollowUpIndex = followUpsLength > 0 ? followUpsLength - 1 : 0;
          const selectedFollowUp = item.selectedFollowUp || `followup-${latestFollowUpIndex + 1}`;
          const selectedFollowUpIndex =
            selectedFollowUp === 'followup-1'
              ? 0
              : selectedFollowUp === 'followup-2'
                ? 1
                : selectedFollowUp === 'followup-3'
                  ? 2
                  : latestFollowUpIndex;

          const followUp = item.followUps?.[selectedFollowUpIndex] || {
            _id: '',
            isFollowUpActive: false,
            status: 'Not Started',
            response: '',
            reminders: new Date().toISOString(),
          };

          return {
            id: item._id,
            srNo: index + 1,
            name: item.name || 'N/A',
            linkedin: item.socials?.linkedIn?.profileUrls?.[0] || 'N/A',
            twitter: item.socials?.twitter?.profileUrls?.[0] || 'N/A',
            facebook: item.socials?.facebook?.profileUrls?.[0] || 'N/A',
            instagram: item.socials?.instagram?.profileUrls?.[0] || 'N/A',
            email: item.email || 'N/A',
            followUpActive: item.followUps?.some((fu) => fu.isFollowUpActive)
              ? 'Active'
              : 'Not Active',
            contacted: item.contacted?.isContacted ? 'Yes' : 'No',
            leadStatus: item.leadStatus || 'N/A',
            followUps: item.followUps || [],
            connectionsType: item.connectionsType || 'N/A',
            contractType: item.contractType || 'N/A',
            userAdditionalInfo: item.userAdditionalInfo || 'N/A',
            comments: item.comments || 'N/A',
            companyName: item.companyName || 'N/A',
            jobTitle: item.jobTitle || 'N/A',
            country: item.country || derivedCountry,
            state: item.state || derivedState,
            city: item.city || derivedCity,
            location: item.location || 'N/A',
            followUpStatus: followUp.status || 'Not Started',
            followUpResponse: followUp.response || '',
            followUpReminder: followUp.reminders || new Date().toISOString(),
            selectedFollowUp: selectedFollowUp,
            companyWebUrl: item.companyWebUrl || 'N/A',
            isConnectionSend: item.isConnectionSend ? 'Yes' : 'No',
            takenBy: item.takenBy || followUp.takenBy || '',
            createdAt: item.createdAt || 'N/A',
          };
        });

        return formattedData;
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      console.error('Error fetching data for export:', error);
      throw error;
    }
  };

  const downloadCSVFile = (csv: string, filename: string) => {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const generateSampleCsvData = () => {
    const headers = [
      'srcUrl',
      'profileSrcUrl',
      'name',
      'socialSrcUrl1',
      'socialSrcUrl2',
      'socialSrcUrl3',
      'socialSrcUrl4',
    ];

    const sampleRows = [
      [
        'https://example.com/profile',
        'https://example.com/profile-image.jpg',
        'John Doe',
        'https://linkedin.com/in/johndoe',
        'https://twitter.com/johndoe',
        'https://instagram.com/johndoe',
        'https://facebook.com/johndoe',
      ],
      [
        'https://example.com/profile2',
        'https://example.com/profile-image2.jpg',
        'Jane Smith',
        'https://linkedin.com/in/janesmith',
        'https://twitter.com/janesmith',
        'https://instagram.com/janesmith',
        'https://facebook.com/janesmith',
      ],
    ];

    const csvContent = [headers.join(','), ...sampleRows.map((row) => row.join(','))].join('\n');
    return csvContent;
  };

  const handleDownloadMasterCsv = () => {
    const csvContent = generateSampleCsvData();
    downloadCSVFile(csvContent, 'master_csv_template');
    setSnackbarMessage('Master CSV template downloaded successfully!');
    setSnackbarType('success');
    setSnackbarOpen(true);
  };

  const getSampleCsvData = () => {
    const headers = [
      'srcUrl',
      'profileSrcUrl',
      'name',
      'socialSrcUrl1',
      'socialSrcUrl2',
      'socialSrcUrl3',
      'socialSrcUrl4',
    ];

    const sampleRows = [
      [
        'https://example.com/profile',
        'https://example.com/profile-image.jpg',
        'John Doe',
        'https://linkedin.com/in/johndoe',
        'https://twitter.com/johndoe',
        'https://instagram.com/johndoe',
        'https://facebook.com/johndoe',
      ],
      [
        'https://example.com/profile2',
        'https://example.com/profile-image2.jpg',
        'Jane Smith',
        'https://linkedin.com/in/janesmith',
        'https://twitter.com/janesmith',
        'https://instagram.com/janesmith',
        'https://facebook.com/janesmith',
      ],
    ];

    return { headers, rows: sampleRows };
  };

  const handleUpload = async (): Promise<void> => {
    if (!file) return;
    const adminRole = Cookies.get('role');
    if (adminRole !== 'admin' && adminRole !== 'superadmin') {
      setSnackbarMessage('Only admins can upload files.');
      setSnackbarOpen(true);
      setSnackbarType('error');
      return;
    }

    setLoadingUpload(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('adminRole', adminRole);

      const token = Cookies.get('token');
      await axios.post(`${process.env.REACT_APP_BASE_URL}/csv/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
          'Accept-Encoding': 'gzip, deflate, br',
        },
        decompress: true,
      });

      setSnackbarMessage('CSV file uploaded successfully!');
      setSnackbarType('success');
      setFile(null);
      setShowButtons('file'); // Show only CoinGecko button
      await fetchAllFiles();
    } catch (error) {
      console.error('Error uploading file:', error);
      setSnackbarMessage('Error uploading CSV file.');
      setSnackbarType('error');
      if (axios.isAxiosError(error) && error.response?.data?.tokenExpired) {
        Cookies.remove('token');
        Cookies.remove('role');
        window.location.href = '/login';
      }
    } finally {
      setLoadingUpload(false);
      setSnackbarOpen(true);
    }
  };

  const handleView = (user: FormattedUser): void => {
    setSelectedUser(user);
  };

  const handleQuickAssign = async (rowId: string, assignedUser: string): Promise<void> => {
    try {
      setAssigningUser(rowId);

      const row = tableData.find((r) => r.id === rowId);
      if (!row) {
        console.error('Row not found');
        setAssigningUser(null);
        return;
      }

      const token = Cookies.get('token');
      const userId = String(rowId);

      if (!/^[a-fA-F0-9]{24}$/.test(userId)) {
        console.error('Invalid User ID format:', userId);
        setAssigningUser(null);
        return;
      }

      // Get the selected follow-up index or use the latest one
      const followUpsLength = row.followUps?.length || 0;
      const latestFollowUpIndex = followUpsLength > 0 ? followUpsLength - 1 : 0;

      const selectedIndex =
        row.selectedFollowUp === 'followup-1'
          ? 0
          : row.selectedFollowUp === 'followup-2'
            ? 1
            : row.selectedFollowUp === 'followup-3'
              ? 2
              : latestFollowUpIndex;

      const selectedFollowUp = row.followUps?.[selectedIndex];

      const editedFields: EditedFields = {};

      // Set takenBy at the root level (as per API response structure)
      editedFields.takenBy = assignedUser || '';

      // If there's a follow-up with an ID, update it (but takenBy is at root level)
      if (selectedFollowUp && selectedFollowUp._id) {
        editedFields.followUpUpdate = {
          followUpId: selectedFollowUp._id,
          isFollowUpActive:
            row.followUpActive === 'Active' || selectedFollowUp.isFollowUpActive || true,
          takenBy: assignedUser || '', // Also keep in follow-up for backward compatibility
          status: selectedFollowUp.status || 'Not Started',
          response: selectedFollowUp.response || '',
          reminders: selectedFollowUp.reminders || new Date().toISOString(),
        };
      } else if (row.followUps && row.followUps.length > 0) {
        // If follow-ups exist but selected one doesn't have _id, use the latest one
        const latestFollowUp = row.followUps[latestFollowUpIndex];
        if (latestFollowUp && latestFollowUp._id) {
          editedFields.followUpUpdate = {
            followUpId: latestFollowUp._id,
            isFollowUpActive:
              row.followUpActive === 'Active' || latestFollowUp.isFollowUpActive || true,
            takenBy: assignedUser || '', // Also keep in follow-up for backward compatibility
            status: latestFollowUp.status || 'Not Started',
            response: latestFollowUp.response || '',
            reminders: latestFollowUp.reminders || new Date().toISOString(),
          };
        } else {
          // Create a new follow-up
          editedFields.followUpUpdate = {
            followUpId: '',
            isFollowUpActive: true,
            takenBy: assignedUser || '', // Also keep in follow-up for backward compatibility
            status: 'Not Started',
            response: '',
            reminders: new Date().toISOString(),
          };
        }
      } else {
        // If no follow-up exists, create one with takenBy
        editedFields.followUpUpdate = {
          followUpId: '',
          isFollowUpActive: true,
          takenBy: assignedUser || '', // Also keep in follow-up for backward compatibility
          status: 'Not Started',
          response: '',
          reminders: new Date().toISOString(),
        };
      }

      editedFields.lastUpdated = [
        {
          updatedAt: new Date(),
          updatedBy: 'frontend-user',
        },
      ];

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/user/updateUser/${userId}`,
        editedFields,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'x-auth-token': token,
          },
        }
      );

      if (response.data.success) {
        setSnackbarMessage('User assigned successfully!');
        setSnackbarType('success');
        setSnackbarOpen(true);
        await fetchAllFiles();
      } else {
        setSnackbarMessage(response.data.message || 'Failed to assign user');
        setSnackbarType('error');
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error('Error assigning user:', error);
      setSnackbarMessage('Error assigning user');
      setSnackbarType('error');
      setSnackbarOpen(true);
    } finally {
      setAssigningUser(null);
    }
  };

  const handleUpdate = async (): Promise<void> => {
    try {
      const userToUpdate = editedData || selectedUser;
      if (!userToUpdate || !userToUpdate.id) {
        console.error('User ID is missing');
        return;
      }
      setLoading(true);

      // Helper function to filter out "N/A" values and normalize empty strings
      const filterNAValues = (value: string | null | undefined): string => {
        if (value === 'N/A' || value === null || value === undefined || value === '') {
          return '';
        }
        return value;
      };

      // Find the original data from tableData
      const originalData = tableData.find((row) => row.id === userToUpdate.id);
      if (!originalData) {
        console.error('Original data not found');
        return;
      }

      // Create an object to store only the edited fields
      const editedFields: EditedFields = {};

      // Compare edited data with original data and only include changed fields
      const newName = filterNAValues(userToUpdate.name);
      const originalName = filterNAValues(originalData.name);
      if (newName !== originalName) {
        editedFields.name = newName;
      }

      const newEmail = filterNAValues(userToUpdate.email);
      const originalEmail = filterNAValues(originalData.email);
      if (newEmail !== originalEmail) {
        editedFields.email = newEmail;
      }

      const newJobTitle = filterNAValues(userToUpdate.jobTitle);
      const originalJobTitle = filterNAValues(originalData.jobTitle);
      if (newJobTitle !== originalJobTitle) {
        editedFields.jobTitle = newJobTitle;
      }

      const newCompanyName = filterNAValues(userToUpdate.companyName);
      const originalCompanyName = filterNAValues(originalData.companyName);
      if (newCompanyName !== originalCompanyName) {
        editedFields.companyName = newCompanyName;
      }

      const newCompanyWeburl = filterNAValues(userToUpdate.companyWebUrl);
      const originalCompanyWeburl = filterNAValues(originalData.companyWebUrl);
      if (newCompanyWeburl !== originalCompanyWeburl) {
        editedFields.companyWebUrl = newCompanyWeburl;
      }

      // Country field updates removed

      const newCity = filterNAValues(userToUpdate.city);
      const originalCity = filterNAValues(originalData.city);
      if (newCity !== originalCity) {
        editedFields.city = newCity;
      }

      const newState = filterNAValues(userToUpdate.state);
      // Original state logic updated to use parseLocation helper or fallback
      const originalState = filterNAValues(
        originalData.state || parseLocation(originalData.location).state
      );
      if (newState !== originalState) {
        editedFields.state = newState;
      }

      const newCountry = filterNAValues(userToUpdate.country);
      const originalCountry = filterNAValues(
        originalData.country || parseLocation(originalData.location).country
      );
      if (newCountry !== originalCountry) {
        editedFields.country = newCountry;
      }

      const newLocation = filterNAValues(userToUpdate.location);
      const originalLocation = filterNAValues(originalData.location);
      if (newLocation !== originalLocation) {
        editedFields.location = newLocation;
      }

      const newLeadStatus = filterNAValues(userToUpdate.leadStatus);
      const originalLeadStatus = filterNAValues(originalData.leadStatus);
      if (newLeadStatus !== originalLeadStatus) {
        editedFields.leadStatus = newLeadStatus;
      }

      const newConnectionsType = filterNAValues(userToUpdate.connectionsType);
      const originalConnectionsType = filterNAValues(originalData.connectionsType);
      if (newConnectionsType !== originalConnectionsType) {
        editedFields.connectionsType = newConnectionsType;
      }

      const newComments = filterNAValues(userToUpdate.comments);
      const originalComments = filterNAValues(originalData.comments);
      if (newComments !== originalComments) {
        editedFields.comments = newComments;
      }

      // Handle isConnectionSent field
      const newConnectionSend = userToUpdate.isConnectionSend === 'Yes';
      const originalConnectionSend = originalData.isConnectionSend === 'Yes';
      if (newConnectionSend !== originalConnectionSend) {
        editedFields.isConnectionSend = newConnectionSend;
      }

      if (userToUpdate.contacted !== originalData.contacted) {
        editedFields.contacted = {
          isContacted: userToUpdate.contacted === 'Yes',
          history: [],
        };
      }

      // Check if any social media links were changed
      const socialsChanged = {
        twitter: filterNAValues(userToUpdate.twitter) !== filterNAValues(originalData.twitter),
        linkedin: filterNAValues(userToUpdate.linkedin) !== filterNAValues(originalData.linkedin),
        instagram:
          filterNAValues(userToUpdate.instagram) !== filterNAValues(originalData.instagram),
        facebook: filterNAValues(userToUpdate.facebook) !== filterNAValues(originalData.facebook),
      };

      if (Object.values(socialsChanged).some((changed) => changed)) {
        editedFields.socials = {
          twitter: {
            profileUrls: [filterNAValues(userToUpdate.twitter)],
            isVerified: false,
          },
          linkedIn: {
            profileUrls: [filterNAValues(userToUpdate.linkedin)],
            isVerified: false,
          },
          instagram: {
            profileUrls: [filterNAValues(userToUpdate.instagram)],
            isVerified: false,
          },
          facebook: {
            profileUrls: [filterNAValues(userToUpdate.facebook)],
            isVerified: false,
          },
        };
      }

      // Check if any follow-up fields were changed
      const selectedIndex =
        userToUpdate.selectedFollowUp === 'followup-1'
          ? 0
          : userToUpdate.selectedFollowUp === 'followup-2'
            ? 1
            : userToUpdate.selectedFollowUp === 'followup-3'
              ? 2
              : 0;

      const selectedFollowUp = userToUpdate.followUps?.[selectedIndex];
      const originalFollowUp = originalData.followUps?.[selectedIndex];

      const isFollowUp = (fu: unknown): fu is FollowUp => {
        if (!fu || typeof fu !== 'object') return false;
        const followUp = fu as Partial<FollowUp>;
        return (
          'isFollowUpActive' in followUp &&
          typeof followUp.isFollowUpActive === 'boolean' &&
          'status' in followUp &&
          'response' in followUp &&
          'reminders' in followUp
        );
      };

      if (isFollowUp(selectedFollowUp) && isFollowUp(originalFollowUp)) {
        // Compare each field individually with the original data
        const isActiveChanged = userToUpdate.followUpActive !== originalData.followUpActive;
        const isStatusChanged = selectedFollowUp.status !== originalFollowUp.status;
        const isResponseChanged = selectedFollowUp.response !== originalFollowUp.response;
        const isReminderChanged = selectedFollowUp.reminders !== originalFollowUp.reminders;
        const isTakenByChanged = userToUpdate.takenBy !== originalData.takenBy;

        // Only include followUpUpdate if any of the fields have changed
        if (
          isActiveChanged ||
          isStatusChanged ||
          isResponseChanged ||
          isReminderChanged ||
          isTakenByChanged
        ) {
          editedFields.followUpUpdate = {
            followUpId: selectedFollowUp._id,
            isFollowUpActive: userToUpdate.followUpActive === 'Active',
            takenBy: userToUpdate.takenBy || Cookies.get('role') || 'admin',
            ...(isStatusChanged && { status: selectedFollowUp.status || 'Not Started' }),
            ...(isResponseChanged && { response: selectedFollowUp.response }),
            ...(isReminderChanged && { reminders: selectedFollowUp.reminders }),
          };
        }
      }

      // Only add lastUpdated if there are actual changes
      if (Object.keys(editedFields).length > 0) {
        editedFields.lastUpdated = [
          {
            updatedAt: new Date(),
            updatedBy: 'frontend-user',
          },
        ];
      }

      const userId = String(userToUpdate.id);

      if (!/^[a-fA-F0-9]{24}$/.test(userId)) {
        console.error('Invalid User ID format:', userId);
        return;
      }

      const token = Cookies.get('token');

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/user/updateUser/${userId}`,
        editedFields,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'x-auth-token': token,
          },
        }
      );

      if (response.data.success) {
        setSelectedUser(null);
        setEditingRow(null);
        setEditedData(null);
        setSnackbarMessage('User details updated!');
        setSnackbarOpen(true);
        setSnackbarType('success');
        await fetchAllFiles();
        setLoading(false);
      } else {
        console.error('Update failed:', response.data.message);
        setLoading(false);
      }
    } catch (error) {
      console.error('Error updating user:', error);
      setLoading(false);
    }
  };

  const handleConfirmDialog = (title: string, message: string, onConfirm: () => void) => {
    setConfirmDialogConfig({ title, message, onConfirm });
    setConfirmDialogOpen(true);
  };

  const handleConfirm = () => {
    if (confirmDialogConfig) {
      confirmDialogConfig.onConfirm();
      setConfirmDialogOpen(false);
      setConfirmDialogConfig(null);
    }
  };

  const handleCancel = () => {
    setConfirmDialogOpen(false);
    setConfirmDialogConfig(null);
  };

  const handelHitLuma = () => {
    handleConfirmDialog(
      'Confirm Luma Processing',
      'Are you sure you want to start Luma processing?',
      async () => {
        setLoadingLuma(true);
        try {
          const token = Cookies.get('token');
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/luma/process-all`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });

          const data = await response.json();
          if (data.success) {
            setSnackbarMessage(data.message || 'Luma processing started successfully!');
            setSnackbarType('success');
          } else {
            setSnackbarMessage('Failed to start Luma processing.');
            setSnackbarType('error');
          }
        } catch (error) {
          console.error('Failed to process Luma request:', error);
          setSnackbarMessage('An error occurred while processing Luma.');
          setSnackbarType('error');
        } finally {
          setLoadingLuma(false);
          setSnackbarOpen(true);
        }
      }
    );
  };

  const handelCoinGecko = () => {
    handleConfirmDialog(
      'Confirm CoinGecko Processing',
      'Are you sure you want to start CoinGecko processing?',
      async () => {
        setLoadingCoinGecko(true);
        try {
          const token = Cookies.get('token');
          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/coingecko/scrape-founders`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const data = await response.json();
          if (data.success) {
            setSnackbarMessage(data.message || 'Coingecko processing started successfully!');
            setSnackbarType('success');
          } else {
            setSnackbarMessage('Failed to start coingecko processing.');
            setSnackbarType('error');
          }
        } catch (error) {
          console.error('Failed to process coingecko:', error);
          setSnackbarMessage('An error occurred while processing coingecko.');
          setSnackbarType('error');
        } finally {
          setLoadingCoinGecko(false);
          setSnackbarOpen(true);
        }
      }
    );
  };

  const handelWebScrap = () => {
    handleConfirmDialog(
      'Confirm Web Scraping',
      'Are you sure you want to start web scraping?',
      async () => {
        setLoadingWebscrap(true);
        try {
          const token = Cookies.get('token');
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/website/scrape-emails`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });

          const data = await response.json();
          if (data.success) {
            setSnackbarMessage(data.message || 'Website scraping started successfully!');
            setSnackbarType('success');
          } else {
            setSnackbarMessage('Failed to start website scraping.');
            setSnackbarType('error');
          }
        } catch (error) {
          console.error('Error hitting website scraping:', error);
          setSnackbarMessage('An error occurred while website scraping.');
          setSnackbarType('error');
        } finally {
          setLoadingWebscrap(false);
          setSnackbarOpen(true);
        }
      }
    );
  };

  const handelInstagramScrap = () => {
    handleConfirmDialog(
      'Confirm Instagram Scraping',
      'Are you sure you want to start Instagram scraping?',
      async () => {
        setLoadingInsta(true);
        try {
          const token = Cookies.get('token');
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/instagram/scrape`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });

          const data = await response.json();
          if (data.success) {
            setSnackbarMessage(data.message || 'Instagram scraping started successfully!');
            setSnackbarType('success');
          } else {
            setSnackbarMessage('Failed to start Instagram scraping.');
            setSnackbarType('error');
          }
        } catch (error) {
          console.error('Error hitting Instagram scraping:', error);
          setSnackbarMessage('An error occurred while Instagram scraping.');
          setSnackbarType('error');
        } finally {
          setLoadingInsta(false);
          setSnackbarOpen(true);
        }
      }
    );
  };

  const handelTwitterScrap = () => {
    handleConfirmDialog(
      'Confirm Twitter Scraping',
      'Are you sure you want to start Twitter scraping?',
      async () => {
        setLoadingTwitter(true);
        try {
          const token = Cookies.get('token');
          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/twitter/process-TweeterProfiles-job`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const data = await response.json();
          if (data.success) {
            setSnackbarMessage(data.message || 'Twitter Scraping started successfully!');
            setSnackbarType('success');
          } else {
            setSnackbarMessage('Failed to start twitter scraping.');
            setSnackbarType('error');
          }
        } catch (error) {
          console.error('failed to load twitter scraping:', error);
          setSnackbarMessage('An error occurred while twitter scraping.');
          setSnackbarType('error');
        } finally {
          setLoadingTwitter(false);
          setSnackbarOpen(true);
        }
      }
    );
  };

  const handelValidateEmail = () => {
    handleConfirmDialog(
      'Confirm Email Validation',
      'Are you sure you want to start email validation?',
      async () => {
        setLoadingEmailValid(true);
        try {
          const token = Cookies.get('token');
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/email/validate-all`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });

          const data = await response.json();
          if (data.success) {
            setSnackbarMessage(data.message || 'Email Validation started successfully!');
            setSnackbarType('success');
          } else {
            setSnackbarMessage('Failed to start email validator.');
            setSnackbarType('error');
          }
        } catch (error) {
          console.error('Failed while Validating email:', error);
          setSnackbarMessage('An error occurred while validating email.');
          setSnackbarType('error');
        } finally {
          setLoadingEmailValid(false);
          setSnackbarOpen(true);
        }
      }
    );
  };

  const handelUrlScrape = () => {
    if (!urlToScrape.trim()) {
      setSnackbarMessage('Please enter a URL to scrape');
      setSnackbarType('error');
      setSnackbarOpen(true);
      return;
    }

    handleConfirmDialog(
      'Confirm URL Scraping',
      `Are you sure you want to scrape people from: ${urlToScrape}?`,
      async () => {
        setLoadingUrlScrape(true);
        try {
          const token = Cookies.get('token');
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/website/scrape-people`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              url: urlToScrape,
            }),
          });

          const data = await response.json();
          console.log('URL Scrape API Response:', data); // Debug log
          console.log('Response status:', response.status); // Debug log
          console.log('Response ok:', response.ok); // Debug log
          console.log('Data success:', data.success); // Debug log

          if (
            response.ok &&
            (data.success || data.status === 'success' || response.status === 200)
          ) {
            console.log('Setting success toast'); // Debug log
            setSnackbarMessage(data.message || 'URL scraping started successfully!');
            setSnackbarType('success');
            setUrlToScrape(''); // Clear the input after successful scrape
            await fetchAllFiles(); // Refresh the data
          } else {
            console.log('Setting error toast'); // Debug log
            setSnackbarMessage(data.message || 'Failed to start URL scraping.');
            setSnackbarType('error');
          }
        } catch (error) {
          console.error('Failed while scraping URL:', error);
          setSnackbarMessage('An error occurred while scraping the URL.');
          setSnackbarType('error');
        } finally {
          setLoadingUrlScrape(false);
          console.log('Final snackbar type:', snackbarType); // Debug log
          setSnackbarOpen(true);
        }
      }
    );
  };

  const handleCsvFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && file.type === 'text/csv') {
      setCsvFile(file);
    } else {
      setSnackbarMessage('Please select a valid CSV file.');
      setSnackbarType('error');
      setSnackbarOpen(true);
    }
  };

  const handleCsvUploadAndScrape = () => {
    if (!csvFile) {
      setSnackbarMessage('Please select a CSV file first.');
      setSnackbarType('error');
      setSnackbarOpen(true);
      return;
    }

    handleConfirmDialog(
      'Confirm CSV Upload & Scrape',
      'Are you sure you want to upload and scrape this CSV file? This will process the CSV data.',
      async () => {
        setLoadingCsvUpload(true);
        try {
          const formData = new FormData();
          formData.append('csvFile', csvFile);

          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/url-scraping-csv/upload`,
            {
              method: 'POST',
              headers: {
                'x-auth-token': Cookies.get('token') || '',
              },
              body: formData,
            }
          );

          const data = await response.json();

          if (
            response.ok &&
            (data.success || data.status === 'success' || response.status === 200)
          ) {
            setSnackbarMessage(data.message || 'CSV uploaded and scraping started successfully!');
            setSnackbarType('success');
            setCsvFile(null); // Clear the file after successful upload
            setShowButtons('csv'); // Show CSV-related buttons
            await fetchAllFiles(); // Refresh the data
          } else {
            setSnackbarMessage(data.message || 'Failed to upload and scrape CSV file.');
            setSnackbarType('error');
          }
        } catch (error) {
          console.error('Error uploading CSV:', error);
          setSnackbarMessage('An error occurred while uploading the CSV file.');
          setSnackbarType('error');
        } finally {
          setLoadingCsvUpload(false);
          setSnackbarOpen(true);
        }
      }
    );
  };

  const handleEditClick = (row: FormattedUser) => {
    const selectedIndex =
      row.selectedFollowUp === 'followup-1'
        ? 0
        : row.selectedFollowUp === 'followup-2'
          ? 1
          : row.selectedFollowUp === 'followup-3'
            ? 2
            : 0;

    const selectedFollowUp = row.followUps?.[selectedIndex] || {
      _id: '',
      isFollowUpActive: true,
      status: 'Not Started',
      response: '',
      reminders: new Date().toISOString(),
    };

    setEditingRow(row.id);
    setEditedData({
      ...row,
      followUpStatus: selectedFollowUp.status,
      followUpResponse: selectedFollowUp.response,
      followUpReminder: selectedFollowUp.reminders,
      followUps:
        row.followUps?.map((fu) => ({
          ...fu,
          _id: fu._id || '', // Ensure _id is preserved
        })) || [],
    });
  };

  const handleDelete = async (row: FormattedUser) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/deleteUser/${row.id}`
      );

      if (response.data.success) {
        setSnackbarMessage(response.data.message || 'User deleted successfully');
        setSnackbarType('success');
        await fetchAllFiles();
      } else {
        setSnackbarMessage(response.data.message || 'Failed to delete user');
        setSnackbarType('error');
      }
      setSnackbarOpen(true); // Add this line to show the snackbar
    } catch (error: unknown) {
      console.error(error);
      const apiError = error as ApiError;
      setSnackbarMessage(apiError?.response?.data?.message || 'Error deleting user');
      setSnackbarType('error');
      setSnackbarOpen(true);
    }
  };

  const handleSaveClick = async () => {
    if (editedData) {
      await handleUpdate();
      setEditingRow(null);
      setEditedData(null);
    }
  };

  const handleCancelClick = () => {
    setEditingRow(null);
    setEditedData(null);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSaveClick();
    }
    // Prevent spacebar from triggering cell navigation
    if (e.key === ' ') {
      e.stopPropagation();
    }
  };

  console.log('Cookies.get', Cookies.get('role'));

  const handleFieldChange = (field: string, value: string) => {
    if (editedData) {
      if (field === 'followUpStatus') {
        // Special handling for followUpStatus
        const updatedFollowUps = [...(editedData.followUps || [])];
        const selectedIndex =
          editedData.selectedFollowUp === 'followup-1'
            ? 0
            : editedData.selectedFollowUp === 'followup-2'
              ? 1
              : editedData.selectedFollowUp === 'followup-3'
                ? 2
                : 0;

        if (updatedFollowUps.length > selectedIndex) {
          updatedFollowUps[selectedIndex] = {
            ...updatedFollowUps[selectedIndex],
            status: value,
          };
        } else {
          // Create empty follow-ups if needed
          while (updatedFollowUps.length <= selectedIndex) {
            updatedFollowUps.push({
              _id: '',
              isFollowUpActive: true,
              status: 'Not Started',
              response: '',
              reminders: new Date().toISOString(),
            });
          }
          updatedFollowUps[selectedIndex].status = value;
        }

        setEditedData({
          ...editedData,
          followUps: updatedFollowUps,
          followUpStatus: value,
        });
      } else if (field === 'followUp.response') {
        // Handle follow-up response
        const updatedFollowUps = [...(editedData.followUps || [])];
        const selectedFollowUpIndex =
          editedData.selectedFollowUp === 'followup-1'
            ? 0
            : editedData.selectedFollowUp === 'followup-2'
              ? 1
              : editedData.selectedFollowUp === 'followup-3'
                ? 2
                : 0;

        if (updatedFollowUps.length > selectedFollowUpIndex) {
          updatedFollowUps[selectedFollowUpIndex] = {
            ...updatedFollowUps[selectedFollowUpIndex],
            response: value,
          };
        } else {
          // Create empty follow-ups if needed
          while (updatedFollowUps.length <= selectedFollowUpIndex) {
            updatedFollowUps.push({
              _id: '',
              isFollowUpActive: true,
              status: 'Not Started',
              response: '',
              reminders: new Date().toISOString(),
            });
          }
          updatedFollowUps[selectedFollowUpIndex].response = value;
        }

        setEditedData({
          ...editedData,
          followUps: updatedFollowUps,
          followUpResponse: value,
        });
      } else if (field === 'followUp.reminders') {
        // Handle follow-up reminder
        const updatedFollowUps = [...(editedData.followUps || [])];
        const selectedFollowUpIndex =
          editedData.selectedFollowUp === 'followup-1'
            ? 0
            : editedData.selectedFollowUp === 'followup-2'
              ? 1
              : editedData.selectedFollowUp === 'followup-3'
                ? 2
                : 0;

        if (updatedFollowUps.length > selectedFollowUpIndex) {
          updatedFollowUps[selectedFollowUpIndex] = {
            ...updatedFollowUps[selectedFollowUpIndex],
            reminders: value,
          };
        } else {
          // Create empty follow-ups if needed
          while (updatedFollowUps.length <= selectedFollowUpIndex) {
            updatedFollowUps.push({
              _id: '',
              isFollowUpActive: true,
              status: 'Not Started',
              response: '',
              reminders: new Date().toISOString(),
            });
          }
          updatedFollowUps[selectedFollowUpIndex].reminders = value;
        }

        setEditedData({
          ...editedData,
          followUps: updatedFollowUps,
          followUpReminder: value,
        } as FormattedUser);
      } else if (field === 'selectedFollowUp') {
        // Handle follow-up selection change
        const selectedIndex =
          value === 'followup-1' ? 0 : value === 'followup-2' ? 1 : value === 'followup-3' ? 2 : 0;

        const selectedFollowUp = editedData.followUps?.[selectedIndex] || {
          _id: '',
          isFollowUpActive: true,
          status: 'Not Started',
          response: '',
          reminders: new Date().toISOString(),
        };

        setEditedData({
          ...editedData,
          selectedFollowUp: value,
          followUpStatus: selectedFollowUp.status,
          followUpResponse: selectedFollowUp.response,
          followUpReminder: selectedFollowUp.reminders,
        });
      } else if (field === 'followUpActive') {
        // Handle follow-up active state change
        const updatedFollowUps = [...(editedData.followUps || [])];
        // If setting to Not Active, clear all follow-ups
        if (value === 'Not Active') {
          updatedFollowUps.length = 0;
        } else if (value === 'Active' && updatedFollowUps.length === 0) {
          // If setting to Active and no follow-ups exist, create one
          updatedFollowUps.push({
            _id: '',
            isFollowUpActive: true,
            status: 'Not Started',
            response: '',
            reminders: new Date().toISOString(),
          });
        }

        // Update isFollowUpActive for all follow-ups
        updatedFollowUps.forEach((fu) => {
          fu.isFollowUpActive = value === 'Active';
        });

        setEditedData({
          ...editedData,
          followUpActive: value,
          followUps: updatedFollowUps,
        });
      } else if (field === 'country') {
        setEditedData({
          ...editedData,
          country: value,
        });
      } else {
        // Handle top-level fields
        setEditedData({
          ...editedData,
          [field]: value,
        });
      }
    }
  };

  const getInitials = (email: string) => {
    if (!email) return 'N/A';
    const parts = email.split('@')[0].split(/[._-]/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return parts[0].slice(0, 2).toUpperCase();
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, row: FormattedUser) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleDeleteClick = (row: FormattedUser) => {
    handleConfirmDialog(
      'Confirm Delete',
      'Are you sure you want to delete this record?',
      async () => {
        await handleDelete(row);
      }
    );
  };

  const handleDeleteConfirm = async () => {
    if (rowToDelete) {
      await handleDelete(rowToDelete);
      setDeleteConfirmOpen(false);
      setRowToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmOpen(false);
    setRowToDelete(null);
  };

  const columns: GridColDef[] = [
    { field: 'srNo', headerName: 'Sr No', width: 80, type: 'number' },
    {
      field: 'createdAt',
      headerName: 'Created At',
      width: 150,
      renderCell: (params) => (
        <Typography variant='body2'>
          {params.value && params.value !== 'N/A'
            ? dayjs(params.value).format('DD MMM YYYY')
            : 'N/A'}
        </Typography>
      ),
    },
    {
      field: 'takenBy',
      headerName: 'Taken By',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        const isAssigning = assigningUser === params.row.id;
        const currentValue =
          editingRow === params.row.id ? editedData?.takenBy || '' : params.row.takenBy || '';

        return (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <Select
              size='small'
              variant='standard'
              value={currentValue}
              onChange={(e) => {
                const newValue = e.target.value;
                if (editingRow === params.row.id) {
                  // If in edit mode, update the editedData
                  handleFieldChange('takenBy', newValue);
                } else {
                  // If not in edit mode, immediately assign
                  if (params.row.id) {
                    handleQuickAssign(String(params.row.id), newValue);
                  }
                }
              }}
              onKeyDown={editingRow === params.row.id ? handleKeyDown : undefined}
              disabled={isAssigning}
              displayEmpty
              disableUnderline
              renderValue={(selected) => {
                const selectedValue = selected || '';
                if (!selectedValue || selectedValue === '') {
                  return (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                      }}
                    >
                      <Typography
                        variant='body2'
                        color='text.secondary'
                        sx={{
                          fontSize: '0.75rem',
                          fontStyle: 'italic',
                          opacity: 0.7,
                        }}
                      >
                        Assign User
                      </Typography>
                    </Box>
                  );
                }
                return (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    <Avatar
                      sx={{
                        background: 'linear-gradient(135deg, #6871d1 0%, #4e54c8 100%)',
                        width: 32,
                        height: 32,
                        fontSize: '0.875rem',
                        fontWeight: 600,
                        boxShadow: '0 2px 8px rgba(104, 113, 209, 0.3)',
                        border: '2px solid rgba(255, 255, 255, 0.1)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'scale(1.1)',
                          boxShadow: '0 4px 12px rgba(104, 113, 209, 0.4)',
                        },
                      }}
                    >
                      {getInitials(selectedValue)}
                    </Avatar>
                  </Box>
                );
              }}
              sx={{
                width: '100%',
                maxWidth: '120px',
                backgroundColor: 'transparent',
                '& .MuiSelect-select': {
                  py: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '40px',
                  border: 'none',
                  backgroundColor: 'transparent',
                  '&:focus': {
                    backgroundColor: 'transparent',
                  },
                },
                '& .MuiInput-underline': {
                  '&:before': {
                    display: 'none',
                  },
                  '&:after': {
                    display: 'none',
                  },
                  '&:hover:not(.Mui-disabled):before': {
                    display: 'none',
                  },
                },
                '& .MuiSelect-icon': {
                  color: 'rgba(255, 255, 255, 0.7)',
                  right: 8,
                },
              }}
            >
              <MenuItem
                value=''
                sx={{
                  '&:hover': {
                    backgroundColor: 'rgba(255, 152, 0, 0.1)',
                  },
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Avatar
                    sx={{
                      background: 'linear-gradient(135deg, #ff9800 0%, #ff6f00 100%)',
                      height: 32,
                      fontSize: '0.875rem',
                      fontWeight: 600,
                      boxShadow: '0 2px 6px rgba(255, 152, 0, 0.25)',
                    }}
                  >
                    —
                  </Avatar>
                  <Typography
                    variant='body2'
                    sx={{
                      fontWeight: 500,
                      fontStyle: 'italic',
                      color: 'text.secondary',
                    }}
                  >
                    Unassign
                  </Typography>
                </Box>
              </MenuItem>
              {users.map((user) => {
                const userIdentifier = user.username || user.email || '';
                return (
                  <MenuItem
                    key={user._id}
                    value={userIdentifier}
                    sx={{
                      '&:hover': {
                        backgroundColor: 'rgba(104, 113, 209, 0.1)',
                      },
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Avatar
                        sx={{
                          background: 'linear-gradient(135deg, #6871d1 0%, #4e54c8 100%)',
                          width: 32,
                          height: 32,
                          fontSize: '0.875rem',
                          fontWeight: 600,
                          boxShadow: '0 2px 6px rgba(104, 113, 209, 0.25)',
                        }}
                      >
                        {getInitials(userIdentifier)}
                      </Avatar>
                      <Typography
                        variant='body2'
                        sx={{
                          fontWeight: 500,
                          color: 'text.primary',
                        }}
                      >
                        {userIdentifier}
                      </Typography>
                    </Box>
                  </MenuItem>
                );
              })}
            </Select>
          </Box>
        );
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 80,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <IconButton
            size='small'
            onClick={(e) => handleMenuClick(e, params.row)}
            sx={{ color: 'white' }}
          >
            <MoreVertIcon />
          </IconButton>
        </Box>
      ),
    },
    {
      field: 'name',
      headerName: 'Name',
      width: 150,
      type: 'string',
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <TextField
            size='small'
            value={editedData?.name || ''}
            onChange={(e) => handleFieldChange('name', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
            autoFocus
          />
        ) : (
          String(params.value || '')
        ),
    },
    {
      field: 'country',
      headerName: 'Country',
      width: 150,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <TextField
            size='small'
            value={editedData?.country || ''}
            onChange={(e) => handleFieldChange('country', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
          />
        ) : (
          params.value
        ),
    },

    {
      field: 'city',
      headerName: 'City',
      width: 150,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <TextField
            size='small'
            value={editedData?.city || ''}
            onChange={(e) => handleFieldChange('city', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
          />
        ) : (
          params.value
        ),
    },
    {
      field: 'state',
      headerName: 'State',
      width: 150,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <TextField
            size='small'
            value={editedData?.state || ''}
            onChange={(e) => handleFieldChange('state', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
          />
        ) : (
          params.value
        ),
    },
    {
      field: 'jobTitle',
      headerName: 'Job Title',
      width: 350,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <TextField
            size='small'
            value={editedData?.jobTitle || ''}
            onChange={(e) => handleFieldChange('jobTitle', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
          />
        ) : (
          params.value
        ),
    },
    {
      field: 'companyName',
      headerName: 'Company Name',
      width: 200,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <TextField
            size='small'
            value={editedData?.companyName || ''}
            onChange={(e) => handleFieldChange('companyName', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
          />
        ) : (
          params.value
        ),
    },
    {
      field: 'companyWebUrl',
      headerName: 'Company Web URL',
      width: 200,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <TextField
            size='small'
            value={editedData?.companyWebUrl || ''}
            onChange={(e) => handleFieldChange('companyWebUrl', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
          />
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography sx={{ flex: 1, fontSize: '0.875rem' }}>
              {params.value === 'N/A' ? (
                'N/A'
              ) : (
                <Link
                  href={params.value}
                  target='_blank'
                  rel='noopener noreferrer'
                  sx={{
                    color: 'primary.main',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  {`${params.value?.slice(0, 20)}..`}
                </Link>
              )}
            </Typography>
            {params.value !== 'N/A' && (
              <Tooltip title='Copy URL'>
                <IconButton
                  size='small'
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(params.value);
                    setSnackbarMessage('Company URL copied!');
                    setSnackbarOpen(true);
                    setSnackbarType('success');
                  }}
                  sx={{
                    padding: '2px',
                    '& .MuiSvgIcon-root': {
                      fontSize: '1rem',
                    },
                  }}
                >
                  <ContentCopyIcon />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        ),
    },
    {
      field: 'linkedin',
      headerName: 'LinkedIn',
      width: 250,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <TextField
            size='small'
            value={editedData?.linkedin || ''}
            onChange={(e) => handleFieldChange('linkedin', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
          />
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography sx={{ flex: 1, fontSize: '0.875rem' }}>
              {params.value === 'N/A' ? (
                'N/A'
              ) : (
                <Link
                  href={params.value}
                  target='_blank'
                  rel='noopener noreferrer'
                  sx={{
                    color: 'primary.main',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  {`${params.value?.slice(0, 20)}..`}
                </Link>
              )}
            </Typography>
            {params.value !== 'N/A' && (
              <Tooltip title='Copy link'>
                <IconButton
                  size='small'
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(params.value);
                    setSnackbarMessage('LinkedIn link copied!');
                    setSnackbarOpen(true);
                    setSnackbarType('success');
                  }}
                  sx={{
                    padding: '2px',
                    '& .MuiSvgIcon-root': {
                      fontSize: '1rem',
                    },
                  }}
                >
                  <ContentCopyIcon />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        ),
    },
    {
      field: 'twitter',
      headerName: 'Twitter',
      width: 250,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <TextField
            size='small'
            value={editedData?.twitter || ''}
            onChange={(e) => handleFieldChange('twitter', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
          />
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography sx={{ flex: 1, fontSize: '0.875rem' }}>
              {params.value === 'N/A' ? (
                'N/A'
              ) : (
                <Link
                  href={params.value}
                  target='_blank'
                  rel='noopener noreferrer'
                  sx={{
                    color: 'primary.main',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  {`${params.value?.slice(0, 20)}..`}
                </Link>
              )}
            </Typography>
            {params.value !== 'N/A' && (
              <Tooltip title='Copy link'>
                <IconButton
                  size='small'
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(params.value);
                    setSnackbarMessage('Twitter link copied!');
                    setSnackbarOpen(true);
                    setSnackbarType('success');
                  }}
                  sx={{
                    padding: '2px',
                    '& .MuiSvgIcon-root': {
                      fontSize: '1rem',
                    },
                  }}
                >
                  <ContentCopyIcon />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        ),
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 250,
      renderCell: (params: any) =>
        editingRow === params.row.id ? (
          <TextField
            size='small'
            value={editedData?.email || ''}
            onChange={(e) => {
              handleFieldChange('email', e.target.value);
              setTrash('false');
            }}
            onKeyDown={handleKeyDown}
            fullWidth
          />
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography sx={{ flex: 1, fontSize: '0.875rem' }}>
              {params.value === 'N/A' ? (
                'N/A'
              ) : (
                <Link
                  href={`https://mail.google.com/mail/?view=cm&fs=1&to=${params.value}`}
                  target='_blank'
                  rel='noopener noreferrer'
                  sx={{
                    color: 'primary.main',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  {params.value}
                </Link>
              )}
            </Typography>
            {params.value !== 'N/A' && (
              <Tooltip title='Copy email'>
                <IconButton
                  size='small'
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(params.value);
                    setSnackbarMessage('Email copied!');
                    setSnackbarOpen(true);
                    setSnackbarType('success');
                  }}
                  sx={{
                    padding: '2px',
                    '& .MuiSvgIcon-root': {
                      fontSize: '1rem',
                    },
                  }}
                >
                  <ContentCopyIcon />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        ),
    },
    {
      field: 'isConnectionSend',
      headerName: 'Connection Sent',
      width: 150,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <Select
            size='small'
            value={editedData?.isConnectionSend || 'No'}
            onChange={(e) => handleFieldChange('isConnectionSend', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
          </Select>
        ) : (
          params.value
        ),
    },
    {
      field: 'contacted',
      headerName: 'Connection Accepted',
      width: 180,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <Select
            size='small'
            value={editedData?.contacted || 'No'}
            onChange={(e) => handleFieldChange('contacted', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
          </Select>
        ) : (
          params.value
        ),
    },

    {
      field: 'followUpActive',
      headerName: 'FollowUp',
      width: 120,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <Select
            size='small'
            value={editedData?.followUpActive || 'Not Active'}
            onChange={(e) => handleFieldChange('followUpActive', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
          >
            <MenuItem value='Active'>Active</MenuItem>
            <MenuItem value='Not Active'>Not Active</MenuItem>
          </Select>
        ) : (
          params.value
        ),
    },
    {
      field: 'followUpStatus',
      headerName: 'FollowUp Status',
      width: 200,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <Box sx={{ display: 'flex', gap: 1 }}>
            {editedData?.followUpActive === 'Active' && (
              <Select
                size='small'
                value={editedData.selectedFollowUp || 'followup-1'}
                onChange={(e) => {
                  const newValue =
                    typeof e.target.value === 'string' ? e.target.value : e.target.value[0];
                  // Extract the number from 'followup-X' format and convert to 0-based index
                  const followUpNumber = parseInt(newValue.split('-')[1] || '1', 10);
                  const selectedIndex = Math.max(0, followUpNumber - 1);

                  // Get the existing follow-up at the selected index
                  const existingFollowUp = editedData.followUps?.[selectedIndex];
                  const isFollowUp = (fu: unknown): fu is FollowUp => {
                    if (!fu || typeof fu !== 'object') return false;
                    const followUp = fu as Partial<FollowUp>;
                    return (
                      'isFollowUpActive' in followUp &&
                      typeof followUp.isFollowUpActive === 'boolean' &&
                      'status' in followUp &&
                      'response' in followUp &&
                      'reminders' in followUp
                    );
                  };

                  const selectedFollowUp = isFollowUp(existingFollowUp)
                    ? existingFollowUp
                    : {
                        _id: '',
                        isFollowUpActive: true,
                        status: 'Not Started',
                        response: '',
                        reminders: new Date().toISOString(),
                      };

                  setEditedData({
                    ...editedData,
                    selectedFollowUp: newValue,
                    followUpStatus: selectedFollowUp.status,
                    followUpResponse: selectedFollowUp.response,
                    followUpReminder: selectedFollowUp.reminders,
                  });
                }}
                onKeyDown={handleKeyDown}
                sx={{ width: '80px' }}
              >
                {Array.from({ length: 15 }, (_, i) => (
                  <MenuItem key={`followup-${i + 1}`} value={`followup-${i + 1}`}>
                    {i + 1}
                  </MenuItem>
                ))}
              </Select>
            )}
            <TextField
              size='small'
              value={editedData?.followUpStatus || ''}
              onChange={(e) => handleFieldChange('followUpStatus', e.target.value)}
              onKeyDown={handleKeyDown}
              fullWidth
            />
          </Box>
        ) : (
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            {params.row.followUpActive === 'Active' ? (
              <>
                <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                  {params.row.selectedFollowUp?.split('-')[1] || '1'}:
                </Typography>
                {params.value || 'Not Started'}
              </>
            ) : (
              'Not Started'
            )}
          </Box>
        ),
    },
    {
      field: 'followUpResponse',
      headerName: 'Follow-up Response',
      width: 250,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <TextField
            size='small'
            value={editedData?.followUpResponse || ''}
            onChange={(e) => handleFieldChange('followUp.response', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
            multiline
            rows={2}
          />
        ) : (
          params.value
        ),
    },

    {
      field: 'followUpReminder',
      headerName: 'Follow-up Reminder',
      width: 200,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <TextField
            size='small'
            type='datetime-local'
            value={
              editedData?.followUpReminder
                ? dayjs(editedData.followUpReminder).format('YYYY-MM-DDTHH:mm')
                : dayjs().format('YYYY-MM-DDTHH:mm')
            }
            onChange={(e) => {
              if (!editedData) return;

              const selectedFollowUpIndex =
                editedData.selectedFollowUp === 'followup-1'
                  ? 0
                  : editedData.selectedFollowUp === 'followup-2'
                    ? 1
                    : editedData.selectedFollowUp === 'followup-3'
                      ? 2
                      : 0;

              const updatedFollowUps = [...(editedData.followUps || [])];
              if (updatedFollowUps.length > selectedFollowUpIndex) {
                updatedFollowUps[selectedFollowUpIndex] = {
                  ...updatedFollowUps[selectedFollowUpIndex],
                  reminders: e.target.value,
                };
              } else {
                // Create empty follow-ups if needed
                while (updatedFollowUps.length <= selectedFollowUpIndex) {
                  updatedFollowUps.push({
                    _id: '',
                    isFollowUpActive: true,
                    status: 'Not Started',
                    response: '',
                    reminders: new Date().toISOString(),
                  });
                }
                updatedFollowUps[selectedFollowUpIndex].reminders = e.target.value;
              }

              setEditedData({
                ...editedData,
                followUps: updatedFollowUps,
                followUpReminder: e.target.value,
              } as FormattedUser);
            }}
            onKeyDown={handleKeyDown}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        ) : params.row.followUpActive === 'Active' ? (
          params.value ? (
            dayjs(params.value).format('YYYY-MM-DD HH:mm:ss')
          ) : (
            'N/A'
          )
        ) : (
          'N/A'
        ),
    },
    {
      field: 'leadStatus',
      headerName: 'Lead Status',
      width: 150,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <Select
            size='small'
            value={editedData?.leadStatus || 'Neutral'}
            onChange={(e) => handleFieldChange('leadStatus', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
            sx={{
              '& .MuiSelect-select': {
                color: 'white',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(255, 255, 255, 0.23)',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(255, 255, 255, 0.5)',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'primary.main',
              },
              '& .MuiSvgIcon-root': {
                color: 'white',
              },
            }}
          >
            <MenuItem value='Neutral'>Neutral</MenuItem>
            <MenuItem value='Hot'>Hot</MenuItem>
            <MenuItem value='Cold'>Cold</MenuItem>
            <MenuItem value='Warm'>Warm</MenuItem>
          </Select>
        ) : (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <Typography>{params.value || 'Neutral'}</Typography>
          </Box>
        ),
    },
    {
      field: 'connectionsType',
      headerName: 'Connection Type',
      width: 150,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <TextField
            size='small'
            value={editedData?.connectionsType || ''}
            onChange={(e) => handleFieldChange('connectionsType', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
          />
        ) : (
          params.value
        ),
    },
    {
      field: 'comments',
      headerName: 'Comments',
      width: 200,
      renderCell: (params) =>
        editingRow === params.row.id ? (
          <TextField
            size='small'
            value={editedData?.comments || ''}
            onChange={(e) => handleFieldChange('comments', e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
            multiline
            rows={2}
          />
        ) : (
          params.value
        ),
    },

    // {
    //   field: 'location',
    //   headerName: 'Location',
    //   width: 200,
    //   renderCell: (params) =>
    //     editingRow === params.row.id ? (
    //       <TextField
    //         size='small'
    //         value={editedData?.location || ''}
    //         onChange={(e) => handleFieldChange('location', e.target.value)}
    //         onKeyDown={handleKeyDown}
    //         fullWidth
    //       />
    //     ) : (
    //       params.value
    //     ),
    // },
  ];

  return (
    <Container sx={{ maxWidth: '1600px !important' }}>
      <Box
        sx={{
          marginBottom: '10px',
          // background: 'linear-gradient(90deg, #23234a 0%, #2b2c3e 100%)',
          // boxShadow: '0 4px 24px 0 rgba(104,113,209,0.10)',
          borderRadius: 4,
          p: 3,
          mb: 3,
          backdropFilter: 'blur(4px)',
        }}
      >
        <Grid container spacing={2} alignItems='flex-start'>
          {/* CSV Processing Actions Section - Equal width with other sections */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                padding: '12px 0',
              }}
            >
              <Typography
                variant='subtitle2'
                sx={{
                  color: '#ffffff',
                  fontWeight: 600,
                  fontSize: '0.8rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  mb: 0.5,
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                }}
              >
                <Box
                  sx={{
                    width: 3,
                    height: 14,
                    background: '#6871d1',
                    borderRadius: 1.5,
                  }}
                />
                CSV Processing Actions
              </Typography>

              {/* CSV File Upload Controls */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                }}
              >
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                  <Button
                    component='label'
                    variant='contained'
                    sx={{
                      background: '#2b2c3e',
                      color: '#6871d1',
                      border: '1.5px solid #6871d1',
                      borderRadius: 2,
                      fontWeight: 600,
                      textTransform: 'capitalize',
                      height: '30px',
                      fontSize: '0.65rem',
                      boxShadow: '0 2px 6px rgba(104,113,209,0.10)',
                      flex: 1,
                      minWidth: '100px',
                      '&:hover': {
                        background: '#6871d1',
                        color: '#fff',
                        transform: 'translateY(-1px)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    Choose CSV
                    <input
                      type='file'
                      accept='.csv'
                      onChange={handleCsvFileChange}
                      style={{ display: 'none' }}
                    />
                  </Button>
                  <Button
                    startIcon={<UploadIcon sx={{ fontSize: '16px' }} />}
                    variant='contained'
                    onClick={handleCsvUploadAndScrape}
                    disabled={!csvFile || loadingCsvUpload}
                    sx={{
                      background: 'linear-gradient(90deg, #6871d1 0%, #4e54c8 100%)',
                      color: '#fff',
                      borderRadius: 2,
                      fontWeight: 600,
                      textTransform: 'capitalize',
                      height: '30px',
                      fontSize: '0.65rem',
                      boxShadow: '0 2px 6px rgba(104,113,209,0.10)',
                      px: 1.5,
                      flex: 1,
                      minWidth: '100px',
                      '&:hover': {
                        background: 'linear-gradient(90deg, #5a62b8 0%, #4248a8 100%)',
                        transform: 'translateY(-1px)',
                        boxShadow: '0 4px 10px rgba(104,113,209,0.3)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    {loadingCsvUpload ? 'Processing..' : 'Upload & Scrape'}
                  </Button>
                  <IconButton
                    onClick={() => setShowCsvPreview(true)}
                    size='small'
                    sx={{
                      color: '#ffffff',
                      border: '1px solid #6871d1',
                      backgroundColor: '#3a3d5a',
                      width: '32px',
                      height: '32px',
                      '&:hover': {
                        background: '#6871d1',
                        borderColor: '#8b9aff',
                        transform: 'scale(1.05)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                    title='Preview CSV Format'
                  >
                    <VisibilityIcon sx={{ color: '#ffffff', fontSize: '18px' }} />
                  </IconButton>
                </Box>
                {csvFile && (
                  <Typography
                    variant='caption'
                    sx={{ color: '#8b9aff', fontWeight: 500, fontSize: '0.7rem' }}
                  >
                    {csvFile.name.length > 25
                      ? `${csvFile.name.substring(0, 25)}...`
                      : csvFile.name}
                  </Typography>
                )}
              </Box>

              {/* CSV Processing Buttons */}
              {(Cookies.get('role') === 'admin' ||
                Cookies.get('role') === 'superadmin' ||
                Cookies.get('role') === 'sales') &&
                showButtons === 'csv' && (
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: 1,
                      width: '100%',
                      mt: 0.5,
                    }}
                  >
                    <Button
                      component='label'
                      variant='contained'
                      disabled={loadingLuma}
                      sx={{
                        background: 'linear-gradient(90deg, #6871d1 0%, #4e54c8 100%)',
                        color: '#fff',
                        borderRadius: 2,
                        fontWeight: 600,
                        textTransform: 'capitalize',
                        height: '30px',
                        fontSize: '0.65rem',
                        boxShadow: '0 2px 6px rgba(104,113,209,0.15)',
                        px: 1.5,
                        flex: '1 1 calc(50% - 4px)',
                        minWidth: '80px',
                        '&:hover': {
                          background: 'linear-gradient(90deg, #5a62b8 0%, #4248a8 100%)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 10px rgba(104,113,209,0.3)',
                        },
                        transition: 'all 0.2s ease',
                      }}
                      onClick={handelHitLuma}
                    >
                      {loadingLuma ? 'Processing..' : 'Hit Luma'}
                    </Button>
                    <Button
                      component='label'
                      variant='contained'
                      disabled={loadingWebscrap}
                      sx={{
                        background: 'linear-gradient(90deg, #6871d1 0%, #4e54c8 100%)',
                        color: '#fff',
                        borderRadius: 2,
                        fontWeight: 600,
                        textTransform: 'capitalize',
                        height: '30px',
                        fontSize: '0.65rem',
                        boxShadow: '0 2px 6px rgba(104,113,209,0.15)',
                        px: 1.5,
                        flex: '1 1 calc(50% - 4px)',
                        minWidth: '80px',
                        '&:hover': {
                          background: 'linear-gradient(90deg, #5a62b8 0%, #4248a8 100%)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 10px rgba(104,113,209,0.3)',
                        },
                        transition: 'all 0.2s ease',
                      }}
                      onClick={handelWebScrap}
                    >
                      {loadingWebscrap ? 'Processing..' : 'Web Scrap'}
                    </Button>
                    <Button
                      component='label'
                      variant='contained'
                      disabled={loadingInsta}
                      sx={{
                        background: 'linear-gradient(90deg, #6871d1 0%, #4e54c8 100%)',
                        color: '#fff',
                        borderRadius: 2,
                        fontWeight: 600,
                        textTransform: 'capitalize',
                        height: '30px',
                        fontSize: '0.65rem',
                        boxShadow: '0 2px 6px rgba(104,113,209,0.15)',
                        px: 1.5,
                        flex: '1 1 calc(50% - 4px)',
                        minWidth: '80px',
                        '&:hover': {
                          background: 'linear-gradient(90deg, #5a62b8 0%, #4248a8 100%)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 10px rgba(104,113,209,0.3)',
                        },
                        transition: 'all 0.2s ease',
                      }}
                      onClick={handelInstagramScrap}
                    >
                      {loadingInsta ? 'Processing..' : 'Instagram Scrap'}
                    </Button>
                    <Button
                      component='label'
                      variant='contained'
                      disabled={loadingTwitter}
                      sx={{
                        background: 'linear-gradient(90deg, #6871d1 0%, #4e54c8 100%)',
                        color: '#fff',
                        borderRadius: 2,
                        fontWeight: 600,
                        textTransform: 'capitalize',
                        height: '30px',
                        fontSize: '0.65rem',
                        boxShadow: '0 2px 6px rgba(104,113,209,0.15)',
                        px: 1.5,
                        flex: '1 1 calc(50% - 4px)',
                        minWidth: '80px',
                        '&:hover': {
                          background: 'linear-gradient(90deg, #5a62b8 0%, #4248a8 100%)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 10px rgba(104,113,209,0.3)',
                        },
                        transition: 'all 0.2s ease',
                      }}
                      onClick={handelTwitterScrap}
                    >
                      {loadingTwitter ? 'Processing..' : 'Twitter Scrap'}
                    </Button>
                    <Button
                      component='label'
                      variant='contained'
                      disabled={loadingEmailValid}
                      sx={{
                        background: 'linear-gradient(90deg, #6871d1 0%, #4e54c8 100%)',
                        color: '#fff',
                        borderRadius: 2,
                        fontWeight: 600,
                        textTransform: 'capitalize',
                        height: '30px',
                        fontSize: '0.65rem',
                        boxShadow: '0 2px 6px rgba(104,113,209,0.15)',
                        px: 1.5,
                        flex: '1 1 100%',
                        minWidth: '80px',
                        '&:hover': {
                          background: 'linear-gradient(90deg, #5a62b8 0%, #4248a8 100%)',
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 10px rgba(104,113,209,0.3)',
                        },
                        transition: 'all 0.2s ease',
                      }}
                      onClick={handelValidateEmail}
                    >
                      {loadingEmailValid ? 'Processing..' : 'Validate Email'}
                    </Button>
                  </Box>
                )}
            </Box>
          </Grid>

          {/* URL Scraping Section - Equal width with other sections */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                padding: '12px 0',
              }}
            >
              <Typography
                variant='subtitle2'
                sx={{
                  color: '#ffffff',
                  fontWeight: 600,
                  fontSize: '0.8rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  mb: 0.5,
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                }}
              >
                <Box
                  sx={{
                    width: 3,
                    height: 14,
                    background: '#6871d1',
                    borderRadius: 1.5,
                  }}
                />
                URL Scraping
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <TextField
                  size='small'
                  placeholder='Enter URL to scrape'
                  value={urlToScrape}
                  onChange={(e) => setUrlToScrape(e.target.value)}
                  sx={{
                    width: '100%',
                    '& .MuiOutlinedInput-root': {
                      height: '32px',
                      fontSize: '12px',
                      backgroundColor: '#2b2c3e',
                      color: '#ffffff',
                      '& fieldset': {
                        borderColor: '#6871d1',
                      },
                      '&:hover fieldset': {
                        borderColor: '#4e54c8',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#4e54c8',
                      },
                      '& input': {
                        color: '#ffffff',
                      },
                    },
                    '& .MuiInputBase-input::placeholder': {
                      color: '#8b9aff',
                      opacity: 0.7,
                    },
                  }}
                />
                <Button
                  variant='contained'
                  disabled={loadingUrlScrape || !urlToScrape.trim()}
                  fullWidth
                  sx={{
                    background: 'linear-gradient(90deg, #6871d1 0%, #4e54c8 100%)',
                    color: '#fff',
                    borderRadius: 2,
                    fontWeight: 600,
                    textTransform: 'capitalize',
                    height: '32px',
                    fontSize: '0.7rem',
                    boxShadow: '0 2px 6px rgba(104,113,209,0.10)',
                    '&:hover': {
                      background: 'linear-gradient(90deg, #5a62b8 0%, #4248a8 100%)',
                      transform: 'translateY(-1px)',
                      boxShadow: '0 4px 10px rgba(104,113,209,0.3)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                  onClick={handelUrlScrape}
                >
                  {loadingUrlScrape ? 'Processing..' : 'Scrape URL'}
                </Button>
              </Box>
            </Box>
          </Grid>

          {/* Regular File Upload Section - Equal width with other sections */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                padding: '12px 0',
              }}
            >
              <Typography
                variant='subtitle2'
                sx={{
                  color: '#ffffff',
                  fontWeight: 600,
                  fontSize: '0.8rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  mb: 0.5,
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                }}
              >
                <Box
                  sx={{
                    width: 3,
                    height: 14,
                    background: '#6871d1',
                    borderRadius: 1.5,
                  }}
                />
                File Upload
              </Typography>
              {/* CoinGecko Button - File Upload Actions */}

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                  <Button
                    component='label'
                    variant='contained'
                    sx={{
                      background: '#2b2c3e',
                      color: '#6871d1',
                      border: '1.5px solid #6871d1',
                      borderRadius: 2,
                      fontWeight: 600,
                      textTransform: 'capitalize',
                      height: '36px',
                      fontSize: '0.75rem',
                      boxShadow: '0 2px 6px rgba(104,113,209,0.10)',
                      flex: 1,
                      minWidth: '100px',
                      '&:hover': {
                        background: '#6871d1',
                        color: '#fff',
                        transform: 'translateY(-1px)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    Choose File
                    <Input
                      type='file'
                      onChange={handleFileChange}
                      sx={{ display: 'none', height: '32px' }}
                    />
                  </Button>
                  <Button
                    startIcon={<UploadIcon sx={{ fontSize: '16px' }} />}
                    variant='contained'
                    onClick={handleUpload}
                    disabled={!file || loadingUpload}
                    sx={{
                      background: 'linear-gradient(90deg, #6871d1 0%, #4e54c8 100%)',
                      color: '#fff',
                      borderRadius: 2,
                      fontWeight: 600,
                      textTransform: 'capitalize',
                      height: '36px',
                      fontSize: '0.75rem',
                      boxShadow: '0 2px 6px rgba(104,113,209,0.10)',
                      px: 1.5,
                      flex: 1,
                      minWidth: '100px',
                      '&:hover': {
                        background: 'linear-gradient(90deg, #5a62b8 0%, #4248a8 100%)',
                        transform: 'translateY(-1px)',
                        boxShadow: '0 4px 10px rgba(104,113,209,0.3)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    {loadingUpload ? 'Uploading..' : 'Upload'}
                  </Button>
                </Box>
                {file && (
                  <Typography
                    variant='caption'
                    sx={{
                      color: '#8b9aff',
                      fontWeight: 500,
                      fontSize: '0.7rem',
                      mt: 0,
                    }}
                  >
                    {file.name.length > 25 ? `${file.name.substring(0, 25)}...` : file.name}
                  </Typography>
                )}
              </Box>
            </Box>
            {(Cookies.get('role') === 'admin' ||
              Cookies.get('role') === 'superadmin' ||
              Cookies.get('role') === 'sales') &&
              showButtons === 'file' && (
                <Button
                  component='label'
                  variant='contained'
                  disabled={loadingCoinGecko}
                  sx={{
                    background: 'linear-gradient(90deg, #6871d1 0%, #4e54c8 100%)',
                    color: '#fff',
                    borderRadius: 2,
                    fontWeight: 600,
                    textTransform: 'capitalize',
                    height: '36px',
                    fontSize: '0.75rem',
                    boxShadow: '0 2px 6px rgba(104,113,209,0.10)',
                    px: 2,
                    alignSelf: 'flex-start',
                    mb: 0.5,
                    '&:hover': {
                      background: 'linear-gradient(90deg, #5a62b8 0%, #4248a8 100%)',
                      transform: 'translateY(-1px)',
                      boxShadow: '0 4px 12px rgba(104,113,209,0.3)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                  onClick={handelCoinGecko}
                >
                  {loadingCoinGecko ? 'Proccessing..' : 'CoinGecko'}
                </Button>
              )}
          </Grid>
        </Grid>
      </Box>

      <Box
        display='flex'
        alignItems='center'
        // gap={1}
        gap='0 36px'
        sx={{
          marginBottom: '30px',
          paddingTop: '25px',
          flexWrap: 'wrap',
          border: '1px solid rgba(255, 255, 255, 0.08)',
          borderRadius: '10px',
          paddingLeft: '20px',
          '& > *': {
            // Target all direct children
            marginBottom: '10px !important', // Add consistent bottom margin
            paddingTop: '0px !important', // Remove extra padding
          },
        }}
      >
        <Box display='flex' alignItems='center'>
          <img
            src={contactedIcon}
            alt='contacted'
            style={{
              width: '25px',
              height: '25px',
              marginRight: '8px',
              filter: 'invert(100%) brightness(100%)',
            }}
          />
          <Typography variant='subtitle1' mr={1}>
            Connection Accepted :
          </Typography>
          <IconButton
            onClick={() => {
              setContacted(contacted === 'true' ? 'false' : 'true');
              setTrash('false');
            }}
          >
            {contacted === 'true' ? (
              <CheckCircleIcon color='primary' fontSize='small' />
            ) : (
              <RadioButtonUncheckedIcon color='disabled' fontSize='small' />
            )}
          </IconButton>
        </Box>

        <Box
          display='flex'
          alignItems='center'
          gap={2}
          sx={{ marginBottom: '30px', paddingTop: '25px' }}
        >
          <Box display='flex' alignItems='center'>
            <img
              src={notConnectedIcon}
              alt='notContacted'
              style={{
                width: '25px',
                height: '25px',
                marginRight: '8px',
                filter: 'invert(100%) brightness(100%)',
              }}
            />
            <Typography variant='subtitle1' mr={1}>
              Not Contacted :
            </Typography>
            <IconButton
              onClick={() => {
                setNotContacted(notContacted === 'true' ? 'false' : 'true');
                setTrash('false');
              }}
            >
              {notContacted === 'true' ? (
                <CheckCircleIcon color='primary' fontSize='small' />
              ) : (
                <RadioButtonUncheckedIcon color='disabled' fontSize='small' />
              )}
            </IconButton>
          </Box>
        </Box>

        <Box display='flex' alignItems='center'>
          <img
            src={linkedinIcon}
            alt='linkedin'
            style={{
              width: '22px',
              height: '22px',
              marginRight: '8px',
              filter: 'invert(100%) brightness(100%)',
            }}
          />
          <Typography variant='subtitle1' mr={1}>
            LinkedIn:
          </Typography>
          <IconButton
            onClick={() => {
              setLinkedin(linkedin === 'true' ? 'false' : 'true');
              setTrash('false');
            }}
          >
            {linkedin === 'true' ? (
              <CheckCircleIcon color='primary' fontSize='small' />
            ) : (
              <RadioButtonUncheckedIcon color='disabled' fontSize='small' />
            )}
          </IconButton>
        </Box>

        <Box display='flex' alignItems='center'>
          <img
            src={twitterIcon}
            alt='twitter'
            style={{
              width: '16px',
              height: '16px',
              marginRight: '8px',
              filter: 'invert(100%) brightness(100%)',
            }}
          />
          <Typography variant='subtitle1' mr={1}>
            Twitter:
          </Typography>
          <IconButton
            onClick={() => {
              setTwitter(twitter === 'true' ? 'false' : 'true');
              setTrash('false');
            }}
          >
            {twitter === 'true' ? (
              <CheckCircleIcon color='primary' fontSize='small' />
            ) : (
              <RadioButtonUncheckedIcon color='disabled' fontSize='small' />
            )}
          </IconButton>
        </Box>

        <Box display='flex' alignItems='center'>
          <img
            src={instagramIcon}
            alt='instagram'
            style={{
              width: '20px',
              height: '20px',
              marginRight: '8px',
              filter: 'invert(100%) brightness(100%)',
            }}
          />
          <Typography variant='subtitle1' mr={1}>
            Instagram:
          </Typography>
          <IconButton
            onClick={() => {
              setIntagram(instagram === 'true' ? 'false' : 'true');
              setTrash('false');
            }}
          >
            {instagram === 'true' ? (
              <CheckCircleIcon color='primary' fontSize='small' />
            ) : (
              <RadioButtonUncheckedIcon color='disabled' fontSize='small' />
            )}
          </IconButton>
        </Box>

        <Box display='flex' alignItems='center'>
          <img
            src={ValidEmail}
            alt='instagram'
            style={{
              width: '25px',
              height: '25px',
              marginRight: '8px',
              filter: 'invert(100%) brightness(100%)',
            }}
          />
          <Typography variant='subtitle1' mr={1}>
            Valid Emails:
          </Typography>
          <IconButton
            onClick={() => {
              setValidEmail(validEmail === 'true' ? 'false' : 'true');
              setTrash('false');
            }}
          >
            {validEmail === 'true' ? (
              <CheckCircleIcon color='primary' fontSize='small' />
            ) : (
              <RadioButtonUncheckedIcon color='disabled' fontSize='small' />
            )}
          </IconButton>
        </Box>

        <Box display='flex' alignItems='center'>
          <img
            src={Email}
            alt='email'
            style={{
              width: '20px',
              height: '20px',
              marginRight: '8px',
              filter: 'invert(100%) brightness(100%)',
            }}
          />
          <Typography variant='subtitle1' mr={1}>
            Emails:
          </Typography>
          <IconButton
            onClick={() => {
              setEmail(email === 'true' ? 'false' : 'true');
              setTrash('false');
            }}
          >
            {email === 'true' ? (
              <CheckCircleIcon color='primary' fontSize='small' />
            ) : (
              <RadioButtonUncheckedIcon color='disabled' fontSize='small' />
            )}
          </IconButton>
        </Box>

        <Box display='flex' alignItems='center'>
          <img
            src={ConnctionIcon}
            alt='facebook'
            style={{
              width: '20px',
              height: '20px',
              marginRight: '8px',
              filter: 'invert(100%) brightness(100%)',
            }}
          />
          <Typography variant='subtitle1' mr={1}>
            Connection Sent:
          </Typography>
          <IconButton
            onClick={() => {
              setFacebook(facebook === 'true' ? 'false' : 'true');
              setTrash('false');
            }}
          >
            {facebook === 'true' ? (
              <CheckCircleIcon color='primary' fontSize='small' />
            ) : (
              <RadioButtonUncheckedIcon color='disabled' fontSize='small' />
            )}
          </IconButton>
        </Box>

        <Box display='flex' alignItems='center'>
          <img
            src={followupIcon}
            alt='followup'
            style={{
              width: '20px',
              height: '20px',
              marginRight: '8px',
              filter: 'invert(100%) brightness(100%)',
            }}
          />
          <Typography variant='subtitle1' mr={1}>
            Follow-up Active:
          </Typography>
          <IconButton
            onClick={() => setFollowUpFilter(followUpFilter === null ? 'followupAll' : null)}
          >
            {followUpFilter !== null ? (
              <CheckCircleIcon color='primary' fontSize='small' />
            ) : (
              <RadioButtonUncheckedIcon color='disabled' fontSize='small' />
            )}
          </IconButton>
        </Box>

        {followUpFilter !== null && (
          <Box display='flex' alignItems='center'>
            <Typography variant='subtitle1' mr={1}>
              Follow-up:
            </Typography>
            <Select
              value={followUpFilter}
              onChange={(e) => {
                const newValue = e.target.value as FollowUpFilterType;
                setFollowUpFilter(newValue);
              }}
              sx={{ minWidth: 200 }}
              renderValue={(selected) => {
                switch (selected) {
                  case 'followup1':
                    return 'Follow-up 1';
                  case 'followup2':
                    return 'Follow-up 2';
                  case 'followup3':
                    return 'Follow-up 3';
                  case 'followupAll':
                    return 'All';
                  default:
                    return 'All';
                }
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                  },
                },
              }}
            >
              <MenuItem value='followup1'>
                <Box display='flex' alignItems='center' gap={1}>
                  {followUpFilter === 'followup1' && (
                    <CheckCircleIcon color='primary' fontSize='small' />
                  )}
                  Follow-up 1
                </Box>
              </MenuItem>
              <MenuItem value='followup2'>
                <Box display='flex' alignItems='center' gap={1}>
                  {followUpFilter === 'followup2' && (
                    <CheckCircleIcon color='primary' fontSize='small' />
                  )}
                  Follow-up 2
                </Box>
              </MenuItem>
              <MenuItem value='followup3'>
                <Box display='flex' alignItems='center' gap={1}>
                  {followUpFilter === 'followup3' && (
                    <CheckCircleIcon color='primary' fontSize='small' />
                  )}
                  Follow-up 3
                </Box>
              </MenuItem>
              <MenuItem value='followupAll'>
                <Box display='flex' alignItems='center' gap={1}>
                  {followUpFilter === 'followupAll' && (
                    <CheckCircleIcon color='primary' fontSize='small' />
                  )}
                  All
                </Box>
              </MenuItem>
            </Select>
          </Box>
        )}

        <Box
          display='flex'
          alignItems='center'
          gap={2}
          sx={{ marginBottom: '30px', paddingTop: '25px' }}
        >
          <Box display='flex' alignItems='center'>
            <img
              src={binIcon}
              alt='notContacted'
              style={{
                width: '20px',
                height: '20px',
                marginRight: '8px',
                filter: 'invert(100%) brightness(100%)',
              }}
            />
            <Typography variant='subtitle1' mr={1}>
              View Trash Users :
            </Typography>
            <IconButton
              onClick={() => {
                setTrash(trash === 'true' ? 'false' : 'true');
                // Reset all filters
                setContacted('false');
                setToken2049('false');
                setIstoken2049SNG25('false');
                setCryptoInvestor('false');
                setCryptoInvestment('false');
                setIsCryptoslate('false');
                setCoinGecko('false');
                setBlocsysConnections('false');
                setNotContacted('false');
                setLinkedin('false');
                setTwitter('false');
                setIntagram('false');
                setFacebook('false');
                setFollowUpFilter(null);
                setStartDate(null);
                setEndDate(null);
                setNameSearch('');
                setLumaFilter('false');
              }}
            >
              {trash === 'true' ? (
                <CheckCircleIcon color='primary' fontSize='small' />
              ) : (
                <RadioButtonUncheckedIcon color='disabled' fontSize='small' />
              )}
            </IconButton>
          </Box>
        </Box>

        <Box display='flex' alignItems='center'>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel
              id='data-source-label'
              sx={{
                // color: 'rgba(255, 255, 255, 0.7)',
                color: 'white',
                border: '1px solid ree',
                '&.Mui-focused': {
                  color: 'primary.main',
                },
              }}
            >
              Data Source
            </InputLabel>
            <Select
              labelId='data-source-label'
              multiple
              value={[
                ...(lumaFilter === 'true' ? ['luma'] : []),
                ...(token2049 === 'true' ? ['token2049'] : []),
                ...(istoken2049SNG25 === 'true' ? ['istoken2049SNG25'] : []),
                ...(cryptoInvestor === 'true' ? ['cryptoInvestor'] : []),
                ...(cryptoInvestment === 'true' ? ['cryptoInvestment'] : []),
                ...(isCryptoslate === 'true' ? ['isCryptoslate'] : []),
                ...(coinGecko === 'true' ? ['coingecko'] : []),
                ...(blocsysConnections === 'true' ? ['blocsysConnections'] : []),
                ...(selectedCsvName ? [`csv_${selectedCsvName}`] : []),
              ]}
              label='Data Source'
              onChange={(e) => {
                const values = e.target.value as string[];
                setLumaFilter(values.includes('luma') ? 'true' : 'false');
                setToken2049(values.includes('token2049') ? 'true' : 'false');
                setIstoken2049SNG25(values.includes('istoken2049SNG25') ? 'true' : 'false');
                setCryptoInvestor(values.includes('cryptoInvestor') ? 'true' : 'false');
                setCryptoInvestment(values.includes('cryptoInvestment') ? 'true' : 'false');
                setIsCryptoslate(values.includes('isCryptoslate') ? 'true' : 'false');
                setCoinGecko(values.includes('coingecko') ? 'true' : 'false');
                setBlocsysConnections(values.includes('blocsysConnections') ? 'true' : 'false');

                // Handle CSV name selection
                const csvValue = values.find((value) => value.startsWith('csv_'));
                if (csvValue) {
                  setSelectedCsvName(csvValue.replace('csv_', ''));
                } else {
                  setSelectedCsvName('');
                }

                setTrash('false');

                // Trigger API call after state updates
                setTimeout(() => {
                  fetchAllFiles();
                }, 0);
              }}
              // size='small'
              renderValue={(selected) => {
                const selectedValues = selected as string[];
                if (selectedValues.length === 0) return 'Select Data Source';
                if (selectedValues.length === 3) return 'All Sources';
                return selectedValues
                  .map((value) => {
                    switch (value) {
                      case 'luma':
                        return 'Luma Scraped';
                      case 'token2049':
                        return 'Token 2049';
                      case 'istoken2049SNG25':
                        return 'Token 2049 SNG25';
                      case 'cryptoInvestor':
                        return 'Crypto Investor';
                      case 'cryptoInvestment':
                        return 'Crypto Investment';
                      case 'isCryptoslate':
                        return 'CryptoSlate';
                      case 'coingecko':
                        return 'CoinGecko';
                      case 'blocsysConnections':
                        return 'Blocsys Connections';
                      default:
                        if (value.startsWith('csv_')) {
                          return value.replace('csv_', '');
                        }
                        return value;
                    }
                  })
                  .join(', ');
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                  },
                },
              }}
            >
              <MenuItem value='luma'>
                <Box display='flex' alignItems='center' gap={1}>
                  {lumaFilter === 'true' && <CheckCircleIcon color='primary' fontSize='small' />}
                  <img
                    src={lumaIcon}
                    alt='luma'
                    style={{
                      width: '20px',
                      height: '20px',
                      filter: 'invert(100%) brightness(100%)',
                    }}
                  />
                  Luma Scraped
                </Box>
              </MenuItem>
              <MenuItem value='token2049'>
                <Box display='flex' alignItems='center' gap={1}>
                  {token2049 === 'true' && <CheckCircleIcon color='primary' fontSize='small' />}
                  <img
                    src={token2049icon}
                    alt='token2049'
                    style={{
                      width: '20px',
                      height: '20px',
                      filter: 'invert(100%) brightness(100%)',
                    }}
                  />
                  Token 2049
                </Box>
              </MenuItem>
              <MenuItem value='istoken2049SNG25'>
                <Box display='flex' alignItems='center' gap={1}>
                  {istoken2049SNG25 === 'true' && (
                    <CheckCircleIcon color='primary' fontSize='small' />
                  )}
                  <img
                    src={token2049icon}
                    alt='istoken2049SNG25'
                    style={{
                      width: '20px',
                      height: '20px',
                      filter: 'invert(100%) brightness(100%)',
                    }}
                  />
                  Token 2049 SNG25
                </Box>
              </MenuItem>
              <MenuItem value='cryptoInvestor'>
                <Box display='flex' alignItems='center' gap={1}>
                  {cryptoInvestor === 'true' && (
                    <CheckCircleIcon color='primary' fontSize='small' />
                  )}
                  <img
                    src={cryptoInvestoricon}
                    alt='cryptoInvestor'
                    style={{
                      width: '20px',
                    }}
                  />
                  Crypto Investor
                </Box>
              </MenuItem>
              <MenuItem value='cryptoInvestment'>
                <Box display='flex' alignItems='center' gap={1}>
                  {cryptoInvestment === 'true' && (
                    <CheckCircleIcon color='primary' fontSize='small' />
                  )}
                  <img
                    src={cryptoInvestmenticon}
                    alt='cryptoInvestment'
                    style={{
                      width: '20px',
                      height: '20px',
                      filter: 'invert(100%) brightness(100%)',
                    }}
                  />
                  Crypto Investment
                </Box>
              </MenuItem>
              <MenuItem value='isCryptoslate'>
                <Box display='flex' alignItems='center' gap={1}>
                  {isCryptoslate === 'true' && <CheckCircleIcon color='primary' fontSize='small' />}
                  <img
                    src={cryptoInvestoricon}
                    alt='isCryptoslate'
                    style={{
                      width: '20px',
                      height: '20px',
                      filter: 'invert(100%) brightness(100%)',
                    }}
                  />
                  CryptoSlate
                </Box>
              </MenuItem>
              <MenuItem value='coingecko'>
                <Box display='flex' alignItems='center' gap={1}>
                  {coinGecko === 'true' && <CheckCircleIcon color='primary' fontSize='small' />}
                  <img
                    src={coinGeko}
                    alt='coingecko'
                    style={{
                      width: '20px',
                      height: '20px',
                      filter: 'invert(100%) brightness(100%)',
                    }}
                  />
                  CoinGecko
                </Box>
              </MenuItem>
              <MenuItem value='blocsysConnections'>
                <Box display='flex' alignItems='center' gap={1}>
                  {blocsysConnections === 'true' && (
                    <CheckCircleIcon color='primary' fontSize='small' />
                  )}
                  <img
                    src={BlocsysConnections}
                    alt='blocsysConnections'
                    style={{
                      width: '20px',
                      height: '20px',
                      filter: 'invert(100%) brightness(100%)',
                    }}
                  />
                  Blocsys Connections
                </Box>
              </MenuItem>
              {/* CSV Names */}
              {csvNames.map((csvName) => (
                <MenuItem key={csvName} value={`csv_${csvName}`}>
                  <Box display='flex' alignItems='center' gap={1}>
                    {selectedCsvName === csvName && (
                      <CheckCircleIcon color='primary' fontSize='small' />
                    )}
                    <img
                      src='/csv-icon.png'
                      alt='csv'
                      style={{
                        width: '20px',
                        height: '20px',
                        filter: 'invert(100%) brightness(100%)',
                      }}
                      onError={(e) => {
                        // Fallback to a simple icon if image fails to load
                        e.currentTarget.style.display = 'none';
                      }}
                    />
                    {csvName}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <FormControl sx={{ width: 200 }}>
            <InputLabel
              id='user-select-label'
              sx={{
                color: 'white',
                '&.Mui-focused': {
                  color: 'primary.main',
                },
              }}
            >
              Filter by User
            </InputLabel>
            <Select
              labelId='user-select-label'
              id='user-select'
              value={selectedUserFilter}
              label='Filter by User'
              onChange={handleUserChange}
              sx={{
                '& .MuiSelect-select': {
                  color: 'white',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255, 255, 255, 0.23)',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'primary.main',
                },
                '& .MuiSvgIcon-root': {
                  color: 'white',
                },
              }}
            >
              <MenuItem value=''>All Users</MenuItem>
              {users.map((user) => (
                <MenuItem key={user._id} value={user.username || user.email}>
                  {user.username || user.email}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2,
        }}
      >
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <TextField
            size='small'
            placeholder='Search by name...'
            value={nameSearch}
            onChange={(e) => setNameSearch(e.target.value)}
            sx={{ width: 200 }}
          />
          <TextField
            label='How many pages?'
            type='number'
            size='small'
            value={exportPages}
            onChange={(e) => setExportPages(e.target.value)}
            inputProps={{ min: 1, max: Math.ceil(rowCount / pageSize) }}
            sx={{
              width: 150,
              background: '#23234a',
              borderRadius: 2,
              color: '#fff',
              '& .MuiInputBase-input': { color: '#fff' },
            }}
            disabled={isExporting}
          />
          <Button
            variant='contained'
            onClick={handleDownloadCSV}
            disabled={isExporting}
            sx={{
              background: 'linear-gradient(90deg, #6871d1 0%, #4e54c8 100%)',
              color: '#fff',
              borderRadius: 2,
              fontWeight: 700,
              textTransform: 'capitalize',
              height: '40px',
              boxShadow: '0 2px 8px rgba(104,113,209,0.10)',
              '&:hover': {
                background: '#2b2c3e',
                color: '#6871d1',
              },
            }}
          >
            {isExporting ? 'Exporting...' : 'Download CSV'}
          </Button>
        </Box>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <DatePicker
              label='Start Date'
              value={startDate}
              onChange={(date) => setStartDate(date)}
              slotProps={{
                textField: {
                  size: 'small',
                  sx: {
                    width: 200,
                    '& .MuiInputBase-root': {
                      height: '40px',
                      fontSize: '14px',
                    },
                  },
                },
              }}
            />
            <DatePicker
              label='End Date'
              value={endDate}
              onChange={(date) => setEndDate(date)}
              slotProps={{
                textField: {
                  size: 'small',
                  sx: {
                    width: 200,
                    '& .MuiInputBase-root': {
                      height: '40px',
                      fontSize: '14px',
                    },
                  },
                },
              }}
            />
            <Button
              variant='contained'
              onClick={fetchAllFiles}
              size='small'
              sx={{
                textTransform: 'capitalize',
                height: '40px',
                fontSize: '14px',
                background: 'linear-gradient(90deg, #6871d1 0%, #4e54c8 100%)',
                color: '#fff',
                borderRadius: 2,
                fontWeight: 700,
                boxShadow: '0 2px 8px rgba(104,113,209,0.10)',
                px: 2.5,
                '&:hover': {
                  background: '#2b2c3e',
                  color: '#6871d1',
                },
              }}
            >
              Filter
            </Button>
            <Button
              variant='outlined'
              onClick={() => {
                setStartDate(null);
                setEndDate(null);
                fetchAllFiles();
              }}
              size='small'
              sx={{
                textTransform: 'capitalize',
                height: '40px',
                fontSize: '14px',
                color: '#6871d1',
                borderColor: '#6871d1',
                borderRadius: 2,
                fontWeight: 700,
                background: '#2b2c3e',
                px: 2.5,
                '&:hover': {
                  background: '#6871d1',
                  color: '#fff',
                  borderColor: '#6871d1',
                },
              }}
            >
              Reset
            </Button>
          </Box>
        </LocalizationProvider>
      </Box>

      <DataGrid
        rows={tableData}
        columns={columns}
        autoHeight
        pagination
        rowCount={rowCount}
        paginationMode='server'
        pageSizeOptions={[10]}
        paginationModel={{ page, pageSize }}
        onPaginationModelChange={(model) => {
          setPage(model.page);
          setPageSize(model.pageSize);
        }}
        loading={loading}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 10, page: 0 },
          },
        }}
        disableRowSelectionOnClick
        onCellDoubleClick={(params) => {
          if (params.field !== 'actions') {
            handleEditClick(params.row);
          }
        }}
        sx={{
          '& .MuiDataGrid-cell': {
            whiteSpace: 'normal',
            cursor: 'pointer',
          },
          '& .MuiDataGrid': {
            minHeight: '100px !important',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          '& .MuiDataGrid-virtualScrollerRenderZone': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          '& .MuiDataGrid-columnHeaders': {
            position: 'sticky',
            top: 0,
            backgroundColor: 'background.paper',
            zIndex: 1,
            borderBottom: '1px solid',
            borderColor: 'divider',
          },
          '& .MuiDataGrid-virtualScroller': {
            overflow: 'auto !important',
            height: '600px !important',
          },
          '& .css-zr1fsd-MuiTypography-root': {
            lineHeight: 3,
            fontSize: '14px',
          },
          '& .css-10xkah2': {
            lineHeight: 3,
            fontSize: '14px',
          },
          '& .css-16lkv3a-MuiTypography-root': {
            lineHeight: 3,
            fontSize: '14px',
          },
          '& .css-1hq8ktp': {
            lineHeight: 3,
            fontSize: '14px',
          },
          '& .MuiDataGrid-cell--textRight ': {
            display: 'flex',
            justifyContent: 'center',
          },
          // Add styling for editing row
          '& .MuiDataGrid-row.Mui-selected': {
            backgroundColor: 'rgba(144, 202, 249, 0.08)',
            '&:hover': {
              backgroundColor: 'rgba(144, 202, 249, 0.12)',
            },
          },
          '& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell': {
            borderColor: 'primary.main',
          },
        }}
        getRowClassName={(params) => {
          return params.row.id === editingRow ? 'Mui-selected' : '';
        }}
      />

      <Dialog
        open={Boolean(selectedUser)}
        onClose={() => {
          setSelectedUser(null);
          setEditedData(null);
        }}
        maxWidth='md'
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            maxHeight: '90vh',
          },
        }}
      >
        <DialogTitle
          sx={{
            pb: 1,
            borderBottom: '1px solid',
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <PersonIcon color='primary' />
          <Typography variant='h5' component='span' sx={{ fontWeight: 600 }}>
            Contact Details
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ pt: 3 }}>
          {selectedUser && (
            <>
              {/* Basic Information Section */}
              <Box sx={{ mb: 3 }}>
                <Typography
                  variant='h6'
                  sx={{
                    mb: 2,
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    color: 'primary.main',
                  }}
                >
                  <PersonIcon fontSize='small' />
                  Basic Information
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Name'
                      value={selectedUser.name || 'N/A'}
                      fullWidth
                      disabled
                      margin='dense'
                      variant='outlined'
                      sx={{ bgcolor: 'action.disabledBackground' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Job Title'
                      value={selectedUser.jobTitle || 'N/A'}
                      fullWidth
                      disabled
                      margin='dense'
                      variant='outlined'
                      sx={{ bgcolor: 'action.disabledBackground' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Company Name'
                      value={selectedUser.companyName || 'N/A'}
                      fullWidth
                      disabled
                      margin='dense'
                      variant='outlined'
                      InputProps={{
                        startAdornment: <BusinessIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                      }}
                      sx={{ bgcolor: 'action.disabledBackground' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Email'
                      value={selectedUser.email || 'N/A'}
                      fullWidth
                      disabled
                      margin='dense'
                      variant='outlined'
                      InputProps={{
                        startAdornment: <EmailIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                      }}
                      sx={{ bgcolor: 'action.disabledBackground' }}
                    />
                  </Grid>
                </Grid>
              </Box>

              <Divider sx={{ my: 3 }} />

              {/* Social Media Links Section */}
              <Box sx={{ mb: 3 }}>
                <Typography
                  variant='h6'
                  sx={{
                    mb: 2,
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    color: 'primary.main',
                  }}
                >
                  <LanguageIcon fontSize='small' />
                  Social Media Links
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='LinkedIn'
                      value={selectedUser.linkedin || 'N/A'}
                      fullWidth
                      disabled
                      margin='dense'
                      variant='outlined'
                      sx={{ bgcolor: 'action.disabledBackground' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Twitter'
                      value={selectedUser.twitter || 'N/A'}
                      fullWidth
                      disabled
                      margin='dense'
                      variant='outlined'
                      sx={{ bgcolor: 'action.disabledBackground' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Facebook'
                      value={selectedUser.facebook || 'N/A'}
                      fullWidth
                      disabled
                      margin='dense'
                      variant='outlined'
                      sx={{ bgcolor: 'action.disabledBackground' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Instagram'
                      value={selectedUser.instagram || 'N/A'}
                      fullWidth
                      disabled
                      margin='dense'
                      variant='outlined'
                      sx={{ bgcolor: 'action.disabledBackground' }}
                    />
                  </Grid>
                </Grid>
              </Box>

              <Divider sx={{ my: 3 }} />

              {/* Contact Status Section */}
              <Box sx={{ mb: 3 }}>
                <Typography
                  variant='h6'
                  sx={{
                    mb: 2,
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    color: 'primary.main',
                  }}
                >
                  <AssignmentIcon fontSize='small' />
                  Contact Status
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Contacted'
                      value={selectedUser.contacted || 'N/A'}
                      fullWidth
                      disabled
                      margin='dense'
                      variant='outlined'
                      sx={{ bgcolor: 'action.disabledBackground' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Lead Status'
                      value={selectedUser.leadStatus || 'N/A'}
                      fullWidth
                      disabled
                      margin='dense'
                      variant='outlined'
                      sx={{ bgcolor: 'action.disabledBackground' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Connections Type'
                      value={selectedUser.connectionsType || 'N/A'}
                      fullWidth
                      disabled
                      margin='dense'
                      variant='outlined'
                      sx={{ bgcolor: 'action.disabledBackground' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Contract Type'
                      value={selectedUser.contractType || 'N/A'}
                      fullWidth
                      disabled
                      margin='dense'
                      variant='outlined'
                      sx={{ bgcolor: 'action.disabledBackground' }}
                    />
                  </Grid>
                </Grid>
              </Box>

              <Divider sx={{ my: 3 }} />

              {/* Follow-up Details Section */}
              <Box sx={{ mb: 2 }}>
                <Typography
                  variant='h6'
                  sx={{
                    mb: 2,
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    color: 'primary.main',
                  }}
                >
                  <AccessTimeIcon fontSize='small' />
                  Follow-up Details
                </Typography>

                <Chip
                  label={selectedUser.followUpActive || 'N/A'}
                  color={selectedUser.followUpActive === 'Active' ? 'success' : 'default'}
                  sx={{ mb: 3 }}
                />

                {selectedUser.followUps?.map((followUp, index) => {
                  const dialogEditedData = editedData || selectedUser;
                  const currentFollowUp = dialogEditedData.followUps?.[index] || followUp;
                  const currentStatus = currentFollowUp.status || 'Not Started';
                  const originalData = tableData.find((u) => u.id === selectedUser.id);
                  const originalStatus = originalData?.followUps?.[index]?.status || 'Not Started';
                  const hasStatusChanged = currentStatus !== originalStatus;

                  // Status color mapping
                  const getStatusColor = (status: string) => {
                    const statusColors: Record<
                      string,
                      'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
                    > = {
                      'Not Started': 'default',
                      'In Progress': 'info',
                      Completed: 'success',
                      'Follow-up Required': 'warning',
                      'No Response': 'error',
                      Contacted: 'info',
                      Interested: 'success',
                      'Not Interested': 'error',
                      'On Hold': 'warning',
                    };
                    return statusColors[status] || 'default';
                  };

                  return (
                    <Box
                      key={followUp._id || index}
                      sx={{
                        mt: 2,
                        mb: 3,
                        p: 3,
                        border: '2px solid',
                        borderColor: hasStatusChanged ? 'warning.main' : 'divider',
                        borderRadius: 3,
                        bgcolor: hasStatusChanged ? 'rgba(255, 152, 0, 0.08)' : 'background.paper',
                        boxShadow: hasStatusChanged ? 2 : 1,
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          boxShadow: 3,
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          mb: 2,
                        }}
                      >
                        <Typography
                          variant='h6'
                          sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}
                        >
                          <AssignmentIcon color='primary' fontSize='small' />
                          Follow-up {index + 1}
                        </Typography>
                        {hasStatusChanged && (
                          <Chip
                            label='Unsaved'
                            color='warning'
                            size='small'
                            sx={{ fontWeight: 600 }}
                          />
                        )}
                      </Box>

                      <FormControl fullWidth margin='dense' sx={{ mb: 2 }}>
                        <InputLabel id={`status-label-${index}`}>Status</InputLabel>
                        <Select
                          labelId={`status-label-${index}`}
                          label='Status'
                          value={currentStatus}
                          onChange={(e) => {
                            const updatedFollowUps = [...(selectedUser.followUps || [])];
                            if (updatedFollowUps[index]) {
                              updatedFollowUps[index] = {
                                ...updatedFollowUps[index],
                                status: e.target.value,
                              };
                            }
                            const updatedUser = {
                              ...selectedUser,
                              followUps: updatedFollowUps,
                            };
                            setSelectedUser(updatedUser);
                            setEditedData(updatedUser);
                          }}
                          sx={{
                            textAlign: 'left',
                            '& .MuiSelect-select': {
                              display: 'flex',
                              alignItems: 'center',
                            },
                          }}
                          renderValue={(value) => (
                            <Chip
                              label={value}
                              color={getStatusColor(value)}
                              size='small'
                              sx={{ fontWeight: 500 }}
                            />
                          )}
                        >
                          <MenuItem value='Not Started'>
                            <Chip label='Not Started' color='default' size='small' sx={{ mr: 1 }} />
                            Not Started
                          </MenuItem>
                          <MenuItem value='In Progress'>
                            <Chip label='In Progress' color='info' size='small' sx={{ mr: 1 }} />
                            In Progress
                          </MenuItem>
                          <MenuItem value='Completed'>
                            <Chip label='Completed' color='success' size='small' sx={{ mr: 1 }} />
                            Completed
                          </MenuItem>
                          <MenuItem value='Follow-up Required'>
                            <Chip
                              label='Follow-up Required'
                              color='warning'
                              size='small'
                              sx={{ mr: 1 }}
                            />
                            Follow-up Required
                          </MenuItem>
                          <MenuItem value='No Response'>
                            <Chip label='No Response' color='error' size='small' sx={{ mr: 1 }} />
                            No Response
                          </MenuItem>
                          <MenuItem value='Contacted'>
                            <Chip label='Contacted' color='info' size='small' sx={{ mr: 1 }} />
                            Contacted
                          </MenuItem>
                          <MenuItem value='Interested'>
                            <Chip label='Interested' color='success' size='small' sx={{ mr: 1 }} />
                            Interested
                          </MenuItem>
                          <MenuItem value='Not Interested'>
                            <Chip
                              label='Not Interested'
                              color='error'
                              size='small'
                              sx={{ mr: 1 }}
                            />
                            Not Interested
                          </MenuItem>
                          <MenuItem value='On Hold'>
                            <Chip label='On Hold' color='warning' size='small' sx={{ mr: 1 }} />
                            On Hold
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label='Response'
                            value={followUp.response || 'N/A'}
                            fullWidth
                            disabled
                            margin='dense'
                            variant='outlined'
                            multiline
                            rows={2}
                            sx={{ bgcolor: 'action.disabledBackground' }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label='Reminder'
                            value={dayjs(followUp.reminders).format('MMM DD, YYYY HH:mm') || 'N/A'}
                            fullWidth
                            disabled
                            margin='dense'
                            variant='outlined'
                            InputProps={{
                              startAdornment: (
                                <AccessTimeIcon sx={{ mr: 1, color: 'text.secondary' }} />
                              ),
                            }}
                            sx={{ bgcolor: 'action.disabledBackground' }}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  );
                })}
              </Box>
            </>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2, pt: 2, gap: 1 }}>
          {editedData &&
            selectedUser &&
            (() => {
              const originalData = tableData.find((u) => u.id === selectedUser.id);
              if (!originalData) return false;
              const updatedFollowUps = editedData.followUps || [];
              const originalFollowUps = originalData.followUps || [];
              const hasChanges = updatedFollowUps.some((updatedFollowUp, index) => {
                const originalFollowUp = originalFollowUps[index];
                return originalFollowUp
                  ? updatedFollowUp.status !== originalFollowUp.status
                  : updatedFollowUp.status && updatedFollowUp.status !== 'Not Started';
              });
              return hasChanges;
            })() && (
              <Typography variant='body2' sx={{ color: 'warning.main', mr: 'auto' }}>
                * You have unsaved changes
              </Typography>
            )}
          <Button
            onClick={() => {
              setSelectedUser(null);
              setEditedData(null);
            }}
            disabled={loading}
            variant='outlined'
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              if (editedData && selectedUser) {
                try {
                  setLoading(true);
                  const originalData = tableData.find((u) => u.id === selectedUser.id);
                  if (!originalData) {
                    console.error('Original data not found');
                    setLoading(false);
                    return;
                  }

                  // Update all follow-ups that have status changes
                  const updatedFollowUps = editedData.followUps || [];
                  const originalFollowUps = originalData.followUps || [];
                  let hasChanges = false;

                  for (let index = 0; index < updatedFollowUps.length; index++) {
                    const updatedFollowUp = updatedFollowUps[index];
                    const originalFollowUp = originalFollowUps[index];

                    if (updatedFollowUp) {
                      // Check if status changed (compare with original or treat as new if no original exists)
                      const isStatusChanged = originalFollowUp
                        ? updatedFollowUp.status !== originalFollowUp.status
                        : updatedFollowUp.status && updatedFollowUp.status !== 'Not Started';

                      if (isStatusChanged) {
                        hasChanges = true;
                        // Set editedData to include the selected follow-up for update
                        const updatedEditedData = {
                          ...editedData,
                          selectedFollowUp: `followup-${index + 1}`,
                          followUpStatus: updatedFollowUp.status,
                          followUpResponse: updatedFollowUp.response || '',
                          followUpReminder: updatedFollowUp.reminders || new Date().toISOString(),
                        };
                        setEditedData(updatedEditedData);
                        await handleUpdate();
                      }
                    }
                  }

                  if (hasChanges) {
                    // Refresh the data after all updates
                    await fetchAllFiles();
                    setSnackbarMessage('Status updated successfully!');
                    setSnackbarOpen(true);
                    setSnackbarType('success');
                  } else {
                    setSnackbarMessage('No changes to save');
                    setSnackbarOpen(true);
                    setSnackbarType('info');
                  }
                  setLoading(false);
                } catch (error) {
                  console.error('Error updating status:', error);
                  setSnackbarMessage('Failed to update status');
                  setSnackbarOpen(true);
                  setSnackbarType('error');
                  setLoading(false);
                }
              }
              setSelectedUser(null);
              setEditedData(null);
            }}
            variant='contained'
            color='primary'
            disabled={loading || !editedData}
            sx={{ minWidth: 100 }}
          >
            {loading ? 'Saving...' : 'Save Changes'}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarType}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            backgroundColor: 'background.paper',
            '& .MuiMenuItem-root': {
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
              },
            },
          },
        }}
      >
        {selectedRow && editingRow === selectedRow.id ? (
          <>
            <MenuItem
              onClick={() => {
                handleSaveClick();
                handleMenuClose();
              }}
            >
              Save
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleCancelClick();
                handleMenuClose();
              }}
            >
              Cancel
            </MenuItem>
          </>
        ) : (
          <>
            <MenuItem
              onClick={() => {
                if (selectedRow) {
                  handleView(selectedRow);
                  handleMenuClose();
                }
              }}
            >
              View
            </MenuItem>
            <MenuItem
              onClick={() => {
                if (selectedRow) {
                  handleEditClick(selectedRow);
                  handleMenuClose();
                }
              }}
            >
              Edit
            </MenuItem>
            {!isSales && (
              <MenuItem
                onClick={() => {
                  if (selectedRow) {
                    handleDeleteClick(selectedRow);
                  }
                }}
              >
                Delete
              </MenuItem>
            )}
          </>
        )}
      </Menu>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteConfirmOpen}
        onClose={handleDeleteCancel}
        PaperProps={{
          sx: {
            backgroundColor: 'background.paper',
            color: 'white',
          },
        }}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this record?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color='inherit'>
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color='error' variant='contained'>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Reusable Confirmation Dialog */}
      <Dialog
        open={confirmDialogOpen}
        onClose={handleCancel}
        PaperProps={{
          sx: {
            backgroundColor: 'background.paper',
            color: 'white',
          },
        }}
      >
        <DialogTitle>{confirmDialogConfig?.title || 'Confirm Action'}</DialogTitle>
        <DialogContent>
          <Typography>
            {confirmDialogConfig?.message || 'Are you sure you want to proceed?'}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color='inherit'>
            Cancel
          </Button>
          <Button onClick={handleConfirm} color='primary' variant='contained'>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* CSV Preview Dialog */}
      <Dialog
        open={showCsvPreview}
        onClose={() => setShowCsvPreview(false)}
        maxWidth='lg'
        fullWidth
        PaperProps={{
          sx: {
            background: 'linear-gradient(180deg, #3a3d5a 0%, #2b2c3e 100%)',
            color: 'white',
            borderRadius: 2,
            boxShadow: '0 12px 48px rgba(104, 113, 209, 0.3)',
            border: '1px solid #6871d1',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 2.5,
            pt: 3,
            px: 3,
            borderBottom: '1px solid #6871d1',
            background: 'linear-gradient(180deg, #3a3d5a 0%, #23234a 100%)',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: 1.5,
                background: 'linear-gradient(135deg, #6871d1 0%, #4e54c8 100%)',
                border: '1px solid rgba(104, 113, 209, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(104, 113, 209, 0.3)',
              }}
            >
              <AssignmentIcon sx={{ color: '#ffffff', fontSize: 26 }} />
            </Box>
            <Box>
              <Typography
                variant='h6'
                sx={{ fontWeight: 700, color: '#ffffff', fontSize: '1.25rem', mb: 0.25 }}
              >
                Master CSV Format Preview
              </Typography>
              <Typography
                variant='caption'
                sx={{
                  color: 'rgba(139, 154, 255, 0.9)',
                  fontSize: '0.8125rem',
                  letterSpacing: '0.3px',
                }}
              >
                Template Structure Guide
              </Typography>
            </Box>
          </Box>
          <IconButton
            onClick={() => setShowCsvPreview(false)}
            sx={{
              color: '#ffffff',
              border: '1px solid #6871d1',
              backgroundColor: '#3a3d5a',
              '&:hover': {
                backgroundColor: '#4e54c8',
                color: 'white',
                borderColor: '#6871d1',
                boxShadow: '0 2px 8px rgba(104, 113, 209, 0.3)',
              },
              transition: 'all 0.2s ease',
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 3, pb: 2, px: 3 }}>
          <Box
            sx={{
              mb: 3,
              mt: 2,
              p: 2.5,
              borderRadius: 1.5,
              background: 'linear-gradient(135deg, #3a3d5a 0%, #2d2e48 100%)',
              border: '1px solid #6871d1',
              boxShadow:
                '0 2px 8px rgba(104, 113, 209, 0.15), inset 0 1px 2px rgba(104, 113, 209, 0.1)',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #6871d1 0%, #4e54c8 100%)',
                  border: '1px solid #8b9aff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mt: 0.5,
                  flexShrink: 0,
                  boxShadow: '0 2px 4px rgba(104, 113, 209, 0.2)',
                }}
              >
                <CheckCircleIcon sx={{ color: '#8b9aff', fontSize: 16 }} />
              </Box>
              <Box>
                <Typography
                  variant='body2'
                  sx={{ color: '#ffffff', fontWeight: 600, mb: 0.75, fontSize: '0.9375rem' }}
                >
                  CSV Format Requirements
                </Typography>
                <Typography
                  variant='body2'
                  sx={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '0.875rem', lineHeight: 1.7 }}
                >
                  Use this template to ensure your CSV file has the correct structure. The file must
                  include all required columns in the exact order shown below.
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              overflow: 'auto',
              maxHeight: '450px',
              border: '1px solid #6871d1',
              borderRadius: 1.5,
              background: 'linear-gradient(180deg, #3a3d5a 0%, #23234a 100%)',
              boxShadow:
                'inset 0 2px 8px rgba(104, 113, 209, 0.2), 0 2px 8px rgba(104, 113, 209, 0.15)',
              position: 'relative',
            }}
          >
            <Box
              component='table'
              sx={{
                width: '100%',
                borderCollapse: 'separate',
                borderSpacing: 0,
                '& th, & td': {
                  borderRight: '1px solid rgba(104, 113, 209, 0.3)',
                  borderBottom: '1px solid rgba(104, 113, 209, 0.3)',
                  padding: '16px 18px',
                  textAlign: 'left',
                  fontSize: '0.875rem',
                  '&:last-child': {
                    borderRight: 'none',
                  },
                },
                '& th': {
                  background: 'linear-gradient(180deg, #6871d1 0%, #4e54c8 100%)',
                  fontWeight: 700,
                  position: 'sticky',
                  top: 0,
                  zIndex: 10,
                  color: '#ffffff',
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                  letterSpacing: '1px',
                  borderBottom: '2px solid #8b9aff',
                  boxShadow: '0 2px 8px rgba(104, 113, 209, 0.2)',
                },
                '& tbody tr': {
                  transition: 'all 0.2s ease',
                  background: '#2b2c3e',
                  '&:nth-of-type(even)': {
                    background: '#3a3d5a',
                  },
                  '&:hover': {
                    background: 'linear-gradient(90deg, #6871d1 0%, #4e54c8 100%)',
                    transform: 'scale(1.001)',
                    boxShadow: 'inset 0 0 0 1px #8b9aff',
                  },
                },
                '& td': {
                  color: 'rgba(255, 255, 255, 0.9)',
                  wordBreak: 'break-word',
                  maxWidth: '200px',
                },
              }}
            >
              <thead>
                <tr>
                  {getSampleCsvData().headers.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {getSampleCsvData().rows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((cell, cellIndex) => (
                      <td key={cellIndex}>
                        <Typography
                          variant='body2'
                          sx={{
                            color: cellIndex === 2 ? '#ffffff' : 'rgba(255, 255, 255, 0.9)',
                            fontWeight: cellIndex === 2 ? 600 : 400,
                            fontSize: '0.8125rem',
                          }}
                        >
                          {cell}
                        </Typography>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Box>
          </Box>

          <Box
            sx={{
              mt: 2.5,
              p: 2,
              borderRadius: 1.5,
              background: 'linear-gradient(135deg, #3a3d5a 0%, #2d2e48 100%)',
              border: '1px solid #6871d1',
              boxShadow: '0 2px 4px rgba(104, 113, 209, 0.1)',
            }}
          >
            <Typography
              variant='caption'
              sx={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '0.8125rem', lineHeight: 1.6 }}
            >
              <strong style={{ color: '#ffffff' }}>Note:</strong> All columns are required. Ensure
              your CSV file matches this exact format before uploading.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            pb: 3,
            pt: 2.5,
            gap: 1.5,
            borderTop: '1px solid #6871d1',
            background: 'linear-gradient(180deg, #3a3d5a 0%, #23234a 100%)',
          }}
        >
          <Button
            onClick={() => setShowCsvPreview(false)}
            variant='outlined'
            sx={{
              color: '#ffffff',
              borderColor: '#6871d1',
              backgroundColor: '#3a3d5a',
              px: 3.5,
              py: 1.25,
              textTransform: 'capitalize',
              fontWeight: 600,
              fontSize: '0.875rem',
              '&:hover': {
                borderColor: '#8b9aff',
                backgroundColor: '#4e54c8',
                color: 'white',
                boxShadow: '0 2px 8px rgba(104, 113, 209, 0.2)',
              },
              transition: 'all 0.2s ease',
            }}
          >
            Close
          </Button>
          <Button
            onClick={handleDownloadMasterCsv}
            variant='contained'
            startIcon={<DownloadIcon />}
            sx={{
              background: 'linear-gradient(90deg, #6871d1 0%, #4e54c8 100%)',
              color: '#fff',
              px: 3.5,
              py: 1.25,
              textTransform: 'capitalize',
              fontWeight: 700,
              fontSize: '0.875rem',
              boxShadow: '0 4px 12px rgba(104, 113, 209, 0.3)',
              '&:hover': {
                background: 'linear-gradient(90deg, #5a62b8 0%, #4248a8 100%)',
                boxShadow: '0 6px 16px rgba(104, 113, 209, 0.4)',
                transform: 'translateY(-1px)',
              },
              transition: 'all 0.2s ease',
            }}
          >
            Download Master CSV
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Contacts;
